/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router';
import {
    object, string, bool, func, shape, arrayOf, array, number,
} from 'prop-types';
import { format, addDays } from 'date-fns';
import mbpLogger from 'mbp-logger';
import {
    Paper,
    TextField,
    Select,
    InputLabel,
    MenuItem,
    Typography,
    FormControl,
    NativeSelect,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import getDeliveryCalendarByProduct from '../../../../../apis/product-apis/getDeliveryCalendarByProduct';
import DeliveryCalendarButtonContainer from './DeliveryCalendarButtonContainer';
import GraphqlCalendarContainer from './GraphqlPDPCalendar/GraphqlCalendarContainer';
import GraphqlPortalLoader from '../../GraphqlCommonComponents/GraphqlPortalLoader';
import ConnectedProductAgeVerificationModal from './ProductAgeVerificationModal';
import GraphqlProductNotAvailableModal from './GraphqlProductNotAvailableModal';
import OneClickPaymentBuilder from './OneClickPayments/OneClickPaymentBuilder';
import FlexModal from './GraphqlPDPCalendar/Partials/FlexModal';
import FlexibleShippingOptions from './GraphqlPDPCalendar/Partials/FlexibleShippingOptions';
import { actions as tagManagerActions } from '../../../../../state/ducks/TagManager';
import { getCountryCodeByCategoryPath } from '../../../../../state/ducks/Checkout/helpers/countryCode';
import { filterInternationalCountry } from '../../../../../state/ducks/Checkout/ducks/Checkout/Checkout-Helper';
import { checkDateHasBackUpProduct } from '../../../../helpers/checkFptGptProductBackUp';
import PersonalizationModal from './PersonalizationModal';
import customBreakpoints from '../../../../helpers/customBreakpoints';
import { isVaseConfigProduct } from '../../../../helpers/vaseConfigurations';
import { getPassportSubscriptionStatus } from '../../../../../state/ducks/Passport/Passport-Selectors';

import { withAuth } from '../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';

import {
    setLocationType,
    validateProductFilterZipcode,
    clearValidatedZipcode,
    resetProductFilterZipcodeValidity,
    setUserSubmittedProductFilterZipcode,
    clearUserSubmittedProductFilterZipcode,
    clearUserSelectedAddress,
    setUserSelectedAddress,
    setProductFilterZipcodeValidity,
    setValidatedZipcode,
    verifyWine,
} from '../../../../../state/ducks/App/App-Actions';
import {
    getLocationType,
    getValidatedZipcode,
    getIsProductFilterZipcodeValid,
    getUserSubmittedProductFilterZipcode,
    getSavedAddress,
    getWineData,
    getSubscriptionFrequencyData,
    getSSRDeviceType,
} from '../../../../../state/ducks/App/App-Selectors';
import { getFeatureFlag } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getActiveABTests } from '../../../../../state/ducks/App/ducks/ABTesting/ABTesting-Selectors';
import memberDucks from '../../../../../state/ducks/Member/ducks';
import { getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getIsAuthenticatedStatus, getIsWriteScopeCheckout } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { getZipByAddressSource } from '../../../../../state/ducks/AddToCart/helpers/preCheckoutAddressNormalizer';
import AddressBookWithPagination from '../../../../pages/Checkout/containers/CheckoutFloral/Partials/AddressBookWidget/AddressBookWithPagination';
import DesktopMobile from '../../../../helpers/DesktopMobile/DesktopMobile';
import { addToCartNewCartServices } from '../../../../../state/ducks/AddToCart/AddToCart-Actions';
import VaseConfigATCError from './GraphqlPDPSkus/VaseConfigurator/VaseConfigATCError';
import LimitedAccessReSignInLink from './LimitedAccessReSignInLink';
import { getBaseCode } from '../../../../helpers/tracking/product/dataLayerProductHelpers';
import AddToCartBuilderObject from './GraphqlFoodAddToCart/Partials/AddToCartBuilderObject';
import { formatDate_MM_dd_yyyy_HH_mm_ss } from './GraphqlPDPCalendar/Partials/Helper/helper';
import isProductListingAd from '../../../../helpers/isProductListingAd';
import AddToCarErrorInline from '../AddToCartErrorInline';
import KlarnaCreditPromotionBadge from '../../../Checkout/KlarnaPaymentOnSiteMessage/KlarnaCreditPromotionBadge/KlarnaCreditPromotionBadge';
import PDPAddonContainer from './StandardProductsPage/variants/PDPAddon/PDPAddonContainer';
import PDPAddonMessage from './StandardProductsPage/variants/PDPAddon/PDPAddonMessage';
// import noop from '../.../../../../../helpers/noop';

const {
    common: {
        commonSelectors: {
            getAddressBookEntries,
            getAddressBookPageNumber,
            getTotalNoOfPages,
            getTotalEntriesAddressBook,
            getUserType,
            getIsPassportUserLoggedIn,
        },
    },
    addressBook: {
        addressBookActions: {
            loadAddressBook,
            removeAddressBook,
        },
    },
} = memberDucks;

const ENTER_KEY = 13;

const styles = (theme) => ({
    root: {
        marginBottom: '20px',
        width: '100%',
        color: '#000',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '10px',
        },
    },
    selectLabel: {
        display: 'block',
    },
    formContainer: {
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '20px',
        },
    },
    formWrapper: {
        position: 'relative',
        width: '50%',
        '&:after': {
            content: '""',
            position: 'absolute',
            top: '18px',
            right: '4px',
            width: '1px',
            height: '45px',
            borderLeft: '1px solid #949494', // Todo: add greys to brand palette
            [theme.breakpoints.down('sm')]: {
                top: '5px',
            },
        },
    },
    formWrapperV2: {
        position: 'relative',
        width: '50%',
        '& .MuiInput-underline': {
            '&:before': {
                borderBottom: 'none',
            },
        },
        '&:after': {
            content: '""',
            position: 'absolute',
            top: '18px',
            right: '4px',
            width: '1px',
            height: '45px',
            [theme.breakpoints.down('sm')]: {
                top: '5px',
            },
        },
        '& .MuiInputLabel-shrink': {
            top: '.05px !important',
        },
        '& .MuiFormLabel-root.Mui-focused': {
            top: '0px',
            borderBottom: 'none',
        },
    },
    zipCodeInput: {
        width: '100%',
        background: 'none',
        display: 'block',  // IE 11
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
            zIndex: 1,
        },
        '& > div': {
            width: '100%', // IE 11
        },
        '& > label': {
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                fontSize: 16,
            },
        },
    },
    zipCodeInputV2: {
        width: '95%',
        background: 'none',
        display: 'block',  // IE 11
        height: '54px',
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
            zIndex: 1,
            border: '1px solid #C4C4C4',
            borderRadius: '3px',
        },
        '& > div': {
            width: '100%',
            paddingLeft: '8px', // IE 11
        },
        '& > label': {
            fontFamily: 'Area Variable, Helvetica',
            paddingLeft: '10px',
            paddingTop: '5px',
            // fontSize: '12px',
            fontWeight: 400,
            lineHeight: '18px',
            letterSpacing: '0.01em',
            color: '#555555',
            top: '-13px',
            fontSize: '16px !important',
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                fontSize: 16,
                top: '-13px',
                fontFamily: 'Area Variable, Helvetica',
                '& .MuiFormLabel-root.Mui-focused': {
                    top: '0px',
                },
            },
        },
    },
    zipCodeInputValid: {
        '&::after': {
            position: 'absolute',
            zIndex: '999',
            backgroundColor: theme.palette.colorSuccess,
            color: theme.palette.white,
            textAlign: 'center',
            content: '"✓"',
            fontSize: '9px',
            fontWeight: 'bold',
            lineHeight: '17px',
            left: '130px',
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            animation: 'fadeZoomIn 0.3s ease-in',
            display: 'inline-block', // IE 11
            [theme.breakpoints.down(600)]: {
                left: '120px',
            },
        },
    },
    zipCodeInputValidV2: {
        '&::after': {
            top: '4px',
            position: 'absolute',
            zIndex: '999',
            backgroundColor: theme?.palette?.primaryButton,
            color: theme.palette.white,
            textAlign: 'center',
            content: '"✓"',
            fontSize: '9px',
            fontWeight: 'bold',
            lineHeight: '17px',
            left: '75px',
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            animation: 'fadeZoomIn 0.3s ease-in',
            display: 'inline-block', // IE 11
            [theme.breakpoints.down(600)]: {
                left: '120px',
            },
            [theme.breakpoints.down(415)]: {
                left: '70px',
            },
        },
    },
    zipCodeInputInvalid: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.cms?.white || '#fff',
            lineHeight: '25px',
            fontSize: '11px',
            fontWeight: '300',
            content: '"Invalid zip code"',
            bottom: '-25px',
            left: 0,
            paddingLeft: '7px',
            width: 'calc(100% - 8px)',
            height: '25px',
            backgroundColor: theme.palette.cms?.red || '#ff0000',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
        },
    },
    addToCartZipCheck: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.cms?.white || '#fff',
            lineHeight: '25px',
            fontSize: '11px',
            fontWeight: '300',
            content: '"Enter a 5 digit zip code"',
            bottom: '-25px',
            left: 0,
            paddingLeft: '7px',
            width: 'calc(100% - 8px)',
            height: '25px',
            backgroundColor: theme.palette.cms?.red || '#ff0000',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
            [theme.breakpoints.down('sm')]: {
                lineHeight: '18px',
                bottom: '-18px',
                width: 'calc(100% - 4px)',
                height: '20px',
            },
        },
    },
    locationWrapper: {
        width: '50%',
        marginTop: '14.5px',
        marginBottom: '26px',
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
        },
    },
    locationWrapperV2: {
        width: '50%',
        marginTop: '14.5px',
        marginBottom: '26px',
        marginLeft: '5px',
        border: '1px solid #C4C4C4',
        borderRadius: '3px',
        paddingLeft: '8px',
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
        },
        '& .MuiInput-underline': {
            '&:before': {
                borderBottom: 'none',
            },
            '&:after': {
                borderBottom: 'none',
            },
        },
    },
    locationTypeLabel: {
        display: 'block',
        width: '100%',
        fontSize: '18px',
        [theme.breakpoints.down('sm')]: {
            fontSize: 16,
        },
    },
    locationTypeLabelV2: {
        display: 'block',
        width: '100%',
        fontSize: '18px',
        paddingTop: '4px',
        [theme.breakpoints.down('sm')]: {
            fontSize: 16,
        },
    },
    locationTypeSelector: {
        width: '100%',
    },
    locationTypeSelectorV2: {
        width: '100%',
        '& .MuiInputBase-input': {
            padding: '4px 0px 5px',
        },
    },
    paperHeaderLink: {
        color: theme.palette.cms?.primary || '#5F3C86',
        cursor: 'pointer',
    },
    paperHeaderLinkV2: {
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '0.02em',
        color: theme.palette.cms?.primary || '#5F3C86',
        cursor: 'pointer',
        textDecoration: 'underline',
        [theme.breakpoints.down(391)]: {
            fontSize: '13px',
        },
        [theme.breakpoints.down(376)]: {
            fontSize: '12px',
        },
        [theme.breakpoints.down(354)]: {
            fontSize: '11.5px',
        },
    },
    paperHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        width: '100%',
        height: '40px',
        padding: '0 20px',
        fontWeight: '600',
        fontSize: '13px',
        lineHeight: '16px',
        background: theme.palette.grey9,
        borderRadius: '4px 4px 0 0',
        [theme.breakpoints.down(768)]: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gridTemplateRows: '1fr',
            '& div:last-child': {
                display: 'flex',
                justifyContent: 'end',
            },
        },
    },
    paperHeaderV2: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        width: '100%',
        height: '40px',
        padding: '0 20px',
        fontWeight: '600',
        fontSize: '13px',
        lineHeight: '16px',
        background: '#ECF9F9',
        borderRadius: '4px 4px 0 0',
        [theme.breakpoints.down(768)]: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gridTemplateRows: '1fr',
            '& div:last-child': {
                display: 'flex',
                justifyContent: 'end',
            },
        },
    },
    pdpDelivery: {
        [theme.breakpoints.down(768)]: {
            paddingRight: '5px',
        },
    },
    pdpDeliveryV2: {
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontWeight: 700,
        lineHeight: '26px',
        letterSpacing: '0.03em',
        [theme.breakpoints.down(768)]: {
            paddingRight: '5px',
        },
        [theme.breakpoints.down(391)]: {
            fontSize: '13px',
        },
        [theme.breakpoints.down(376)]: {
            fontSize: '12px',
        },
        [theme.breakpoints.down(354)]: {
            fontSize: '11.5px',
        },
    },
    paperHeaderPla: {
        '@media screen and (max-width: 1280px) and (min-width: 1026px)': {
            display: 'block',
            height: '53px',
            padding: '10px 13px',
        },
    },

    paperBody: {
        boxSizing: 'border-box',
        padding: '13px 20px 20px 20px',
    },
    buttonCalendarInvalidZip: {
        background: 'grey',
    },
    buttonDivider: {
        margin: '10px 0',
        width: '100%',
        textAlign: 'center',
    },
    buttonBuyNow: {
        width: '100%',
        height: '40px',
        color: 'white',
        textAlign: 'center',
        lineHeight: '40px',
        background: '#000',
        borderRadius: '4px',
        cursor: 'pointer',
    },
    buttonAddToCart: {
        marginTop: '5px',
        width: '100%',
        height: '40px',
        color: 'white',
        textAlign: 'center',
        lineHeight: '40px',
        background: '#2ac670',
        borderRadius: '4px',
        cursor: 'pointer',
    },
    containerPosition: {
        marginTop: '-25px',
        [theme.breakpoints.down(1100)]: {
            marginTop: '15px',
        },
        [theme.breakpoints.down(600)]: {
            marginTop: '0px',
        },
    },
    labelPay: {
        fontSize: '14px',
        lineHeight: '20px',
        '& svg': {
            display: 'inline-block',
            width: '15px',
            height: '15px',
            [theme.breakpoints.down(600)]: {
                marginTop: '13px',
            },
        },
        '& > span': {
            display: 'inline-block',
            width: 'calc(100% - 42px)',
            verticalAlign: 'top',
            margin: '10px 3px',
        },
        '& span > span': {
            fontWeight: 'bold',
        },
    },
    '@keyframes stroke': {
        '100%': {
            strokeDashoffset: '0',
        },
    },
    '@keyframes scale': {
        '0%, 100%': {
            transform: 'none',
        },
        '50%': {
            transform: 'scale3d(1.1, 1.1, 1)',
        },
    },
    '@keyframes fill': {
        '100%': {
            boxShadow: `inset 0px 0px 0px 40px ${theme?.palette?.primaryButton}`,
        },
    },
    checkmarkCircle: {
        strokeDasharray: '166',
        strokeDashoffset: '166',
        strokeWidth: '2',
        strokeMiterlimit: '10',
        stroke: theme?.palette?.primaryButton,
        fill: 'none',
    },
    checkMarkContainer: {
        top: '8px',
        position: 'absolute',
        zIndex: '999',
        color: theme.palette.white,
        textAlign: 'center',
        fontSize: '9px',
        fontWeight: 'bold',
        lineHeight: '17px',
        left: '75px',
        width: '15px',
        height: '15px',
        borderRadius: '50%',
        display: 'inline-block', // IE 11
        [theme.breakpoints.down(600)]: {
            top: '-8px',
            zIndex: 0,
        },
    },
    checkmark: {
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        display: 'inline-block',
        strokeWidth: 4,
        stroke: theme?.palette?.white,
        strokeMiterlimit: '10',
        marginRight: 8,
        verticalAlign: 'middle',
        boxShadow: `inset 0px 0px 0px ${theme?.palette?.primaryButton}`,
        animation: '$fill .4s ease-in-out .4s forwards, $scale .3s ease-in-out .9s both',

        [theme.breakpoints.down('600')]: {
            width: '24px',
            height: '24px',
        },
    },
    checkmarkCheck: {
        transformOrigin: '50% 50%',
        strokeDasharray: '38',
        strokeDashoffset: '5',
    },
    newProductUI: {
        '& $root': {
            boxShadow: 'none',
            [theme.breakpoints.down('880')]: {
                marginTop: '16px',
            },
        },
        '& $paperBody': {
            padding: '20px 16px',
        },
        '& $formContainer': {
            display: 'block',
        },
        '& $formWrapper , $formWrapperV2': {
            width: '100%',
            '&:after': {
                content: 'inherit',
            },
        },
        '& $zipCodeInputInvalid , $addToCartZipCheck': {
            '& > label': {
                color: '#ff0000',
            },
            '& input': {
                border: '1px solid #ff0000',
            },
            '&:before': {
                width: 'calc(100% - 10px)',
            },
            [theme.breakpoints.down('880')]: {
                '&:before': {
                    lineHeight: '15px',
                    height: '16px',
                    bottom: '-7px',
                    fontSize: '12px',
                    width: '100%',
                },
            },
        },
        '& $locationWrapper': {
            width: '100%',
            marginTop: '20px',
            marginBottom: '0px',
            '& .MuiFormControl-root': {
                width: '100%',
            },
        },
        '& $zipCodeInput , $zipCodeInputV2': {
            '& input': {
                border: '1px solid #C4C4C4',
                borderRadius: '3px',
                padding: '23.3px 12px 9px',
            },
            [theme.breakpoints.up('880')]: {
                paddingRight: '10px',
                '& input': {
                    padding: '23.5px 12px 9px',
                },
            },
            '& [class*="shrink"]': {
                top: 15,
                fontSize: '12px',
                lineHeight: '18px',
                [theme.breakpoints.up('880')]: {
                    transform: 'translate(14px, -6px) scale(0.75)',
                },
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'transparent',
            },
            '& > label': {
                lineHeight: '26px',
                color: '#555555',
                fontSize: '16px',
                [theme.breakpoints.up('880')]: {
                    transform: 'translate(14px, 20px) scale(1)',
                },
            },
        },
        '& .card-isle-right': {
            '@media screen and (min-width:600px) and (max-width: 762px)': {
                width: 'calc(100% - 106px)',
            },
        },
        '& .card-isle-left': {
            '@media screen and (min-width:600px) and (max-width: 762px)': {
                width: '100px',
            },
        },
        '& .card-isle-button': {
            '@media screen and (min-width:600px) and (max-width: 762px)': {
                width: '150px !important',
                fontSize: '13px',
            },
        },
        '& $zipCodeInputV2': {
            width: '100%',
            height: '56px',
            border: '0px !important',
            '& > label': {
                padding: '0px',
                top: '0px',
            },
            '& > div': {
                paddingLeft: '0px',
            },
        },
        '& $formWrapperV2': {
            '& .MuiInputLabel-shrink': {
                top: '15px !important',
                fontSize: '12px !important',
            },
            '& $zipCodeInputInvalid , $addToCartZipCheck': {
                '& > label': {
                    color: '#ff0000',
                },
                [theme.breakpoints.down('880')]: {
                    '&:before': {
                        lineHeight: '15px',
                        height: '16px',
                        bottom: '-7px',
                        fontSize: '12px',
                        width: '100%',
                    },
                },
            },
        },
        [theme.breakpoints.up('880')]: {
            padding: '24px 8px 8px',
            '& $formContainer': {
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'flex-start',
            },
            '& $zipCodeInput , $locationForm , $zipCodeInputV2': {
                margin: '4px 0px 24px',
            },
            '& $zipCodeInput > div , $zipCodeInputV2 > div ': {
                margin: '0px',
                height: '56px',
            },
            '&  $locationForm': {
                paddingLeft: '10px',
            },
            '& $paperBody': {
                padding: '24px 16px 0px',
            },

        },
        '& $paperHeaderLink , $paperHeaderLinkV2': {
            color: theme.palette.cms?.black || '#000000',
            cursor: 'pointer',
            fontSize: '14px',
            lineHeight: '20px',
            marginTop: '24px',
            textDecoration: 'underline',
            textTransform: 'capitalize',
            textUnderlineOffset: '5px',
            textDecorationThickness: '2px',
            fontFamily: 'Area Variable, LatoBold',
            fontWeight: 700,
        },
        '& $paperHeader , $paperHeaderV2': {
            display: 'block',
            padding: '0 16px',
            width: '100%',
            height: '100%',
            background: 'inherit',
            '& div:last-child': {
                display: 'flex',
                justifyContent: 'start',
            },
        },
        '& $pdpDelivery , $pdpDeliveryV2': {
            fontSize: '24px',
            lineHeight: '30px',
            letterSpacing: '0.5px',
            fontFamily: 'Area Variable, LatoBold',
            fontWeight: '700',
            '@media screen and (min-width:635px) and (max-width: 880px)': {
                fontSize: '20px',
                paddingRight: '0px',
            },
            '@media screen and (min-width:600px) and (max-width: 635px)': {
                fontSize: '18px',
                paddingRight: '0px',
            },
            [theme.breakpoints.down('600px')]: {
                fontSize: '20px',
                lineHeight: '26px',
            },
        },
        '& $locationSelect': {
            width: '100%',
            minHeight: '56px',
            border: 'solid 1px #C4C4C4',
            borderRadius: 3,
            padding: '2px 12px 2px 0px',
            margin: '0px !important',
            background: theme.palette.tiers?.card?.backgroundColor,
            '& :focus': {
                background: '#ffffff',
            },
            '& .MuiNativeSelect-select': {
                color: theme.palette.giftFinderSelectColor,
                fontSize: '18px',
                lineHeight: '26px',
                padding: '17px 12px 0px',
                minHeight: '26px',
            },
            '& .MuiNativeSelect-filled': {
                border: 'solid 1px #C4C4C4',
                borderRadius: 3,
            },
            '& svg': {
                fill: '#000000',
                top: 'calc(50% - 6px)',
            },

        },
        '& $selectLabel': {
            top: '13px',
            left: '0px',
            color: '#555555',
            fontSize: '12px',
            lineHeight: '18px',
            [theme.breakpoints.up('880')]: {
                left: '10px',
            },
        },
        '& $zipCodeInputValid': {
            '&::after': {
                top: '8px',
                left: '103px',
            },
        },
    },
    locationSelect: {},
    locationForm: {
        width: '100%',
        marginTop: '20px',
    },
    deliveryWrapper: {
        [theme.breakpoints.down('600')]: {
            '& $paperHeader, $formContainer': {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            },
            '& $formWrapper , $formWrapperV2': {
                margin: '0px 6px 0px 0px',
            },
            '& $locationForm': {
                margin: '0px 0px 0px 6px',
            },
            '& $zipCodeInput , $zipCodeInputV2': {
                '& input': {
                    padding: '23px 12px 9px',
                },
            },
            '& $pdpDelivery': {
                fontSize: '14px',
                lineHeight: '20px',
                textTransform: 'uppercase',
            },
            '& $paperHeaderLink': {
                marginTop: '0px',
            },
            '& $paperBody': {
                padding: '16px',
            },
            '& $zipCodeInputValid': {
                '&::after': {
                    top: '8px',
                    left: '60px',
                },
            },
        },
    },
    pdpShortStyle: {
        '& $root': {
            [theme.breakpoints.down('600')]: {
                marginBottom: '0px',
            },
        },
        '& $paperBody': {
            [theme.breakpoints.down('600')]: {
                padding: '20px 16px 0px',
            },
        },
        '& $formContainer': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            [theme.breakpoints.down('600')]: {
                marginBottom: '0px',
            },
        },
        '& $formWrapper , $formWrapperV2': {
            margin: '0px 6px 0px 0px',
            [theme.breakpoints.up('600')]: {
                margin: '0px',
            },
        },
        '& $locationForm': {
            paddingLeft: '6px',
            margin: '0px 0px 24px',
        },
        '& $zipCodeInput , $zipCodeInputV2': {
            paddingRight: '6px',
            margin: '0px 0px 24px',
            [theme.breakpoints.down('600')]: {
                paddingRight: '0px',
            },
        },
        '@media screen and (min-width: 600px) and (max-width:700px)': {
            '& $paperBody': {
                padding: '24px 0px 0px',
            },
            '& $paperHeader': {
                padding: '0px !important',
            },
            '& $locationForm': {
                paddingLeft: '4px',
            },
            '& $zipCodeInput , $zipCodeInputV2': {
                paddingRight: '4px !important',
            },
        },
        '& $paperHeader': {
            '& div:last-child': {
                [theme.breakpoints.up('600')]: {
                    marginTop: '4px',
                    fontSize: '16px',
                },
            },
        },
        '& $deliveryWrapper': {
            [theme.breakpoints.down('600')]: {
                '& $paperHeader, $formContainer': {
                    marginBottom: '0px',
                },
            },
        },
    },
    pdpPlaStyle: {
        padding: '0px',
        '& $root': {
            margin: '0px',

        },
        '& $paperHeaderLink , $paperHeaderLinkV2': {
            margin: '0px',
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '0.16px',
            '@media screen and (max-width: 600px)': {
                lineHeight: '20px',
                fontSize: '14px',
            },
        },
        '& $paperBody': {
            padding: '18px 0px 0px',
        },
        '& $locationForm': {
            paddingLeft: '6px',
        },
        '& $zipCodeInput': {
            paddingRight: '6px',
        },
        '& $zipCodeInput , $locationForm , $zipCodeInputV2': {
            margin: '0px 0px 16px',
            '& label': {
                fontSize: '14px',
                '@media screen and (max-width: 1280px) and (min-width:1024px)': {
                    fontSize: '12px',
                },
                '@media screen and (max-width: 380px)': {
                    fontSize: '12px',
                },
            },
            '@media screen and (max-width: 600px)': {
                margin: '0px 0px 20px',
            },
        },
        '& $formContainer': {
            marginBottom: '0px',
            display: 'flex',
        },
        '& $formWrapper , $formWrapperV2': {
            margin: '0px 0px 0px 0px',
        },
        '& $paperHeader, $paperHeaderV2': {
            padding: '0px',
        },
        '& $zipCodeInputInvalid , $addToCartZipCheck': {
            '&:before': {
                width: 'calc(100% - 6px)',
            },
        },
        '& $locationSelect': {
            '& .MuiNativeSelect-select': {
                fontSize: '14px',
            },
        },
    },
    deliveryOptionsAddToCartZipCheck: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.cms?.red || '#ff0000',
            lineHeight: '25px',
            fontSize: '11px',
            fontWeight: '300',
            content: '"ZIP Code required"',
            bottom: '-25px',
            left: 0,
            paddingLeft: '7px',
            width: 'calc(100% - 8px)',
            height: '25px',
            // backgroundColor: theme.palette.cms?.red || '#ff0000',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
            [theme.breakpoints.down('sm')]: {
                lineHeight: '18px',
                bottom: '-18px',
                width: 'calc(100% - 4px)',
                height: '20px',
            },
        },
    },
    deliveryDateOptionsContainter: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        fontFamily: 'Area Variable',
        gap: '16px',
    },
    deliveryDateOptionsTitle: {
        color: 'var(--ENT-gray-700, #434343)',
        fontFamily: 'Area Variable',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '21px', /* 131.25% */
        letterSpacing: '0.64px',
        textTransform: 'uppercase',
    },
    deliveryDateOptionsCopy: {
        color: 'var(--ENT-gray-700, #434343)',
        fontFamily: 'Area Variable',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '19px', /* 135.714% */
    },
    deliveryDateOptions: {
        height: '85px',
        padding: '12px',
        flexDirection: 'column',
        alignItems: 'center',
        flex: '1 0 0',
        borderRadius: 'var(--Border-Radius, 5px)',
        border: '1px solid var(--Selector-Stroke, #F0F0F5)',
        background: 'var(--Selector-BG, #F9F9FB)',
        color: '#000',
        textAlign: 'center',
        fontFamily: 'Area Variable',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '21px', /* 131.25% */
        letterSpacing: '0.16px',
        gap: '2px',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.down('1030')]: {
            fontSize: '14px',
            padding: '12px 0',
        },
        [theme.breakpoints.down('850')]: {
            fontSize: '14px',
            padding: '6px 0',
        },
    },
    deliveryDateOptionsPLA: {
        fontSize: '12px',
        padding: 0,
    },
    deliveryDateOptionSelected: {
        border: '1px solid var(--Selector-Stroke, #201648)',
    },
    deliveryDateButtonsContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-around',
        gap: '12px',
        marginBottom: '16px',
    },
    deliveryDateOptionsSurchargeMessage: {
        color: '#000',
        textAlign: 'center',
        fontFamily: 'Area Variable',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '19px', /* 135.714% */
        letterSpacing: '0.14px',
        [theme.breakpoints.down('850')]: {
            fontSize: '13px',
        },
        [theme.breakpoints.down('802')]: {
            fontSize: '12px',
        },
        [theme.breakpoints.down('420')]: {
            fontSize: '11px',
        },
        [theme.breakpoints.down('321')]: {
            lineHeight: '15px',
        },
    },
    deliveryDateOptionsSurchargeMessagePLA: {
        fontSize: '12px',
    },
    deliveryDateOptionsNoZip: {
        color: 'var(--ENT-gray-900, #000)',
        textAlign: 'center',
        fontFamily: 'Area Variable',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '21px', /* 131.25% */
        letterSpacing: '0.16px',
        [theme.breakpoints.down('321')]: {
            fontSize: '14px',
        },
    },
    zipRequired: {
        color: '#000',
        textAlign: 'center',
        fontFamily: 'Area Variable',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '19px', /* 135.714% */
        letterSpacing: '0.14px',
        [theme.breakpoints.down('376')]: {
            fontSize: '12px',
        },
    },
    addonWrapper: {
        padding: '28px 0px',
        borderTop: '1px solid  var(--ENT-gray-100, #E9E9E9)',
        marginTop: '16px',
    },

});

const isCandaZip = (zipcode) => new RegExp(/^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[- ]{0,1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}/).test(zipcode);

const getNow = (todayOrTom) => {
    const d = new Date();
    if (todayOrTom === 'tomorrow') {
        const newDate = d.getDate() + 1;
        d.setDate(newDate);
        d.setHours(0, 0, 0, 0);
        return d;
    }
    d.setHours(0, 0, 0, 0);
    return d;
}; // 12:00 midnight of current day

const backupLocationTypeOptions = ['Residence', 'Business', 'Funeral home', 'Hospital', 'Apartment', 'School', 'Church'];
const foodBrandLocationTypeOptions = ['Residence', 'Business', 'APO/FPO'];
export class GraphqlAddToCartContainerUI extends Component {
    constructor(props) {
        super(props);
        const {
            userSubmittedZip, featureFlags, productDeliveryType, validatedZip,
        } = this.props;
        this.state = {
            zipField: userSubmittedZip || validatedZip,
            showCalendar: false,
            showAgeVerification: false,
            calendarIsLoading: false,
            deliveryAvailable: true,
            signinIsLoading: false,
            ageDetails: {
                birthDay: '0',
                birthMonth: '0',
                birthYear: '0',
                minAge: '0',
            },
            todayTomArray: [],
            startDateString: '',
            todayTomDateNotAvailText: '',
            personalization: {
                modalOpen: false,
            },
            fireCalendarQuery: false,
            gptSkipCalendarVariantFlowEnabled: (featureFlags['is-skip-calendar-flow-enabled-gpt']?.variant === 'VARIANT A' && productDeliveryType === 'GPT'),
            fireZipCheckQuery: false,
            flexModalOpen: false,
            flexData: null,
            flexTaggingData: null,
            deliveryDateOption: '',
            dateSelectedFromCalendar: {},
            activeButton: 'button1',
            optionOneDate: '',
            optionTwoDate: '',
            productIsNotAvailable: null,
            dateWithSurchargeAvailable: true,
            dateWithoutSurchargeAvailable: true,
            deliveryDateOptionsFlexDetails: null,
            flexDetailsAvailable: false,
            personalizationAdded: false,
        };
        this.zipFieldRef = React.createRef();
    }

    componentDidMount() {
        const {
            zipValid, resetFilterZipcodeValidity, callLoadAddressBook, userType, featureFlags, productDeliveryType, trackEvent,
            isWriteScopeCheckout, userSubmittedZip, variantDeliveryOptions,
        } = this.props;
        const { zipField } = this.state;
        const isDeliveryDateOptionsEnabled = featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled'] && variantDeliveryOptions;
        if (zipValid === false) {
            resetFilterZipcodeValidity();
        }
        if (userType === 'R' && isWriteScopeCheckout) {
            callLoadAddressBook();
        }
        if (isDeliveryDateOptionsEnabled && ((zipValid === true && zipField.length >= 5) || (userSubmittedZip !== '' && zipField === userSubmittedZip))) {
            this.deliveryDateOptionsGetCalendarAPI();
        }
        if (productDeliveryType === 'GPT') {
            if (featureFlags['is-skip-calendar-flow-enabled-gpt']?.variant === 'VARIANT A') {
                // if the pdp is direct loaded then GA will not have loaded and need to queue the trackEvent
                // however if user navigates to pdp then GA is already loaded and need to dispatch a non-queued version of trackEvent
                trackEvent({
                    eventCategory: 'Test Impression',
                    eventAction: 'GPT No Calendar Variant',
                    queued: true,
                });
                trackEvent({
                    eventCategory: 'Test Impression',
                    eventAction: 'GPT No Calendar Variant',
                });
            }
        }
    }

    componentDidUpdate(prevProps) {
        const {
            userType, callLoadAddressBook, wineValidation, isWriteScopeCheckout, userSubmittedZip, validatedZip, showProductTitleTop, featureFlags, device, variantDeliveryOptions, locationType,
        } = this.props;
        const {
            showCalendar,
            showAgeVerification,
            gptSkipCalendarVariantFlowEnabled,
            zipField,
        } = this.state;
        const isDeliveryDateOptionsEnabled = featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled'] && variantDeliveryOptions;
        const isPdpDeliveryTopEnabled =  featureFlags['is-pdp-delivery-top-enabled'] && device === 'mobile' && showProductTitleTop;
        // stop loading once pdp sign-in is complete
        if (prevProps.userType === 'G' && userType === 'R') {
            this.setState({ signinIsLoading: false });
        }
        if (isPdpDeliveryTopEnabled && (prevProps.validatedZip !== validatedZip || prevProps.userSubmittedZip !== userSubmittedZip)) {
            this.setState(
                {
                    zipField: validatedZip || userSubmittedZip,
                },
                this.validateZip,
            );
        }
        if (isDeliveryDateOptionsEnabled && prevProps.locationType !== locationType) {
            this.deliveryDateOptionsGetCalendarAPI('today');
        }
        if ((prevProps.validatedZip !== validatedZip || prevProps.userSubmittedZip !== userSubmittedZip) && zipField.length >= 5 && isDeliveryDateOptionsEnabled) {
            this.handleDeliveryAvailability(true);
            this.deliveryDateOptionsGetCalendarAPI('today');
            this.setState({ activeButton: 'button1', dateWithSurchargeAvailable: true, dateWithoutSurchargeAvailable: true });
        }
        if (!showCalendar && showAgeVerification && this.getAvailability(wineValidation)) {
            if (!gptSkipCalendarVariantFlowEnabled) {
                this.showCalendar();
            } else {
                this.simpleAddToCart();
            }
        }

        // load address book when user signs in
        if ((prevProps.userType === 'G' || prevProps.userType === '' || !prevProps.isWriteScopeCheckout)
            && userType === 'R'
            && isWriteScopeCheckout) {
            callLoadAddressBook();
        }
    }

    getInternationalCountry = () => {
        let countryCode = '';
        const { selectedSku } = this.props;
        if (selectedSku?.countries?.length > 0) {
            countryCode = filterInternationalCountry(selectedSku.countries);
        }
        return countryCode;
    }

    handleDeliveryAvailability = (boolean) => {
        this.setState({ deliveryAvailable: boolean });
    };

    handleCalendarModal = () => {
        const { productSkus } = this.props;
        if (productSkus[0].ageVerifyFlag === 'true') {
            this.setState({ showCalendar: false, showAgeVerification: true });
        } else {
            this.setState({ showCalendar: true, fireCalendarQuery: true });
        }
    };

    showCalendar = () => {
        const { showAgeVerification } = this.state;
        if (showAgeVerification) {
            this.handleAgeVerificationClose();
        }
        this.setState({ showCalendar: true, calendarIsLoading: true });
    }

    closeCalendar = () => {
        const { featureFlags, variantDeliveryOptions } = this.props;
        const { todayTomArray, activeButton } = this.state;
        const today = todayTomArray?.[0]?.deliveryDate || format(new Date(), 'yyyy-MM-dd');
        const isDeliveryDateOptionsEnabled = featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled'] && variantDeliveryOptions;
        this.setState({ showCalendar: false, calendarIsLoading: false });
        if (isDeliveryDateOptionsEnabled && activeButton === 'button1') {
            this.deliveryDateOptionsGetCalendarAPI();
        }
        if (isDeliveryDateOptionsEnabled && activeButton === 'button2') {
            this.setState({
                deliveryDateOption: today !== format(new Date(), 'yyyy-MM-dd') ? 'tomorrow' : 'today',
            });
        }
    };

    handleLocationTypeChange = (e) => {
        const { setLocation, trackEvent } = this.props;
        trackEvent({
            eventCategory: 'Product Page',
            eventAction: 'Location Type',
            eventLabel: e.target.value,
        });
        setLocation(e.target.value);
    };

    calendarButtonNoZip = () => {
        const element = document?.getElementById('add-zipcode-text-field');
        if (element) {
            element.focus();
        }
    };

    convertZipCode = (zipcode, preState) => {
        // handle zipcode conversion for canda
        if (preState.length < zipcode.length
            && zipcode.length >= 6
            && isCandaZip(zipcode)) {
            const zipSplit = zipcode.replace(/\s/gi, '').toUpperCase().split('');
            zipSplit.splice(3, 0, ' ');
            return zipSplit.join('');
        }
        return zipcode;
    }

    handleZipChange = (e) => {
        let zipCode = e.target.value;
        const { zipField } = this.state;
        this.setState({ fireZipCheckQuery: false });
        if (isCandaZip(zipCode)) {
            zipCode = this.convertZipCode(zipCode, zipField);
        }
        this.setState(
            {
                zipField: zipCode,
            },
            this.validateZip,
        );
    };

    handleZipFieldKeyPress = (event) => {
        const { todayTomArray } = this.state;
        const { featureFlags, variantDeliveryOptions } = this.props;
        const today = todayTomArray?.[0]?.deliveryDate || format(new Date(), 'yyyy-MM-dd');
        const tomorrow = todayTomArray?.[1]?.deliveryDate || format(addDays(new Date(), 1), 'yyyy-MM-dd');
        const isDeliveryDateOptionsEnabled = featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled'] && variantDeliveryOptions;
        if ((event.which && event.which === ENTER_KEY) || (event.keyCode && event.keyCode === ENTER_KEY)) {
            event.preventDefault();
            if (isDeliveryDateOptionsEnabled) {
                this.handleDeliveryDateOptionSelected('tomorrow', today, tomorrow, 'button1');
            } else {
                this.fullCalendarCall();
            }
        }
    };

    setCalendarDataLoadingFlag = (boolean) => {
        this.setState({ calendarIsLoading: boolean });
    };

    displayZipValidCSSCheck = () => {
        const { zipField, fireZipCheckQuery } = this.state;
        const {
            zipValid, classes, userSubmittedZip, featureFlags, displayDeliveryCalendar, variantDeliveryOptions,
        } = this.props;
        const isDeliveryDateOptionsEnabled = featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled'] && variantDeliveryOptions;
        if (
            (zipValid === true && zipField.length >= 5)
            || (userSubmittedZip !== '' && zipField === userSubmittedZip)
        ) {
            return `${featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.zipCodeInputV2 : classes.zipCodeInput} ${featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? '' : classes.zipCodeInputValid}`;
        }
        if (zipValid === false && zipField.length >= 5) {
            return `${featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.zipCodeInputV2 : classes.zipCodeInput} ${classes.zipCodeInputInvalid}`;
        }
        if (fireZipCheckQuery && zipField.length < 5) {
            return `${featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.zipCodeInputV2 : classes.zipCodeInput} ${isDeliveryDateOptionsEnabled ? classes.deliveryOptionsAddToCartZipCheck : classes.addToCartZipCheck}`;
        }
        return `${featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.zipCodeInputV2 : classes.zipCodeInput}`;
    };

    validateZip = () => {
        // this function determines when to validate a zipcode that the user enters
        const { zipField } = this.state;
        const {
            valZip,
            clearValidatedZip,
            zipValid,
            resetZipValidity,
            validatedZip,
            clearFilterZip,
            userSubmittedZip,
            featureFlags,
            variantDeliveryOptions,
        } = this.props;
        const isDeliveryDateOptionsEnabled = featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled'] && variantDeliveryOptions;
        if (zipField.length >= 5) {
            // if user enters five chars check if valid zip
            valZip(zipField);
        } else if (zipField.length < 5 && validatedZip !== '') {
            // if there are fewer than 5 chars and there exists a zip in redux clear it
            // we do this so that if someone enters a zipcode, then deletes it the filtering goes away.
            clearValidatedZip();
            if (isDeliveryDateOptionsEnabled) {
                this.setState({ deliveryDateOption: '' });
            }
        }
        if (zipField.length < 5 && userSubmittedZip !== '') {
            clearFilterZip();
            if (isDeliveryDateOptionsEnabled) {
                this.setState({ deliveryDateOption: '' });
            }
        }
        if (zipField.length !== 5 && zipValid !== null) {
            // reset the zip is valid flag in redux if zip is not characters.
            resetZipValidity();
            if (isDeliveryDateOptionsEnabled) {
                this.setState({ deliveryDateOption: '' });
            }
        }
    };

    submitUserSelectedZipcode = () => {
        const { zipField } = this.state;
        const {
            validatedZip,
            setFilterZip,
            userSubmittedZip,
            savedAddress,
            clearSavedAddress,
            isPersistAddressEnabled,
        } = this.props;
        if (validatedZip === zipField) {
            setFilterZip(zipField.trimEnd());
        }
        if (userSubmittedZip !== getZipByAddressSource(savedAddress, isPersistAddressEnabled) && !['expressCheckout', 'buyAgain'].includes(savedAddress.addressSource)) {
            // if an address is saved in guided nav but then the user enters a new zipcode in PDP
            // this resets the saved address in redux so it does not incorrectly prefill the previously
            // selected address
            clearSavedAddress();
        }
    };

    handleProductNotAvailableClose = () => {
        const { featureFlags, variantDeliveryOptions } = this.props;
        const { todayTomArray } = this.state;
        const isDeliveryDateOptionsEnabled = featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled'] && variantDeliveryOptions;
        const tomorrow = todayTomArray?.[1]?.deliveryDate || format(addDays(new Date(), 1), 'yyyy-MM-dd');
        const tomorrowDate = tomorrow || format(addDays(new Date(), 1), 'yyyy-MM-dd');
        const tomorrowDateSelected = tomorrowDate.split('-').join('/');
        const formattedTomorrowDate = format(new Date(tomorrowDateSelected), 'yyyy-MM-dd');
        this.setState({ deliveryAvailable: true, showCalendar: false, calendarIsLoading: false });
        if (isDeliveryDateOptionsEnabled) {
            this.setState({
                deliveryDateOption: tomorrow !== format(addDays(new Date(), 1), 'yyyy-MM-dd') ? formattedTomorrowDate : 'tomorrow',
                activeButton: 'button1',
            });
        }
    };

    handleAgeVerificationClose = () => {
        this.setState({ showAgeVerification: false });
    }

    /*
    * @description get the availability from API response
    * @param {object} data
    */
    getAvailability = (data) => {
        let availability = false;
        if (!data?.wineAvailability) {
            return false;
        }
        const keys = Object.keys(data.wineAvailability);
        keys.forEach((key) => {
            if (data.wineAvailability[key]?.isProductAvailable) {
                availability = true;
            }
        });
        return availability;
    }

    getAgeVerificationDetails = (birthDay, birthMonth, birthYear) => {
        const { zipField, gptSkipCalendarVariantFlowEnabled } = this.state;
        const {
            productSkus, partNumber, brandId, callVerifyWine,
        } = this.props;

        const { minAge } = productSkus[0];
        this.setState({
            ageDetails: {
                birthDay,
                birthMonth,
                birthYear,
                minAge,
            },
        });

        if (partNumber && (zipField || gptSkipCalendarVariantFlowEnabled) && birthMonth && birthYear && birthDay) {
            const wineData = {
                birthDay,
                birthMonth,
                birthYear,
                brandCode: brandId,
                minAge,
                skuPartNumber: partNumber,
                zipCodes: [zipField],
            };
            callVerifyWine(wineData);
        }
    }

    addTodayOrTomToCart = (todayOrTom) => {
        const {
            validatedZip, userSubmittedZip, trackEvent, location, partNumber,
        } = this.props;
        const { zipField } = this.state;
        const subscriptionProduct = location?.search?.includes('subscription');
        trackEvent({
            eventCategory: subscriptionProduct ? 'subscription' : 'Product Page',
            eventAction: subscriptionProduct ? 'conversion' : 'Purchasing Option',
            eventLabel: subscriptionProduct ? getBaseCode(partNumber) : 'One Time',
            eventValue: '1',
        });
        if ((validatedZip !== '' && validatedZip === zipField) || (userSubmittedZip !== '' && zipField === userSubmittedZip)) {
            trackEvent({ eventCategory: 'Product Page', eventAction: 'Delivery Option Selected', eventLabel: todayOrTom });
            this.submitUserSelectedZipcode();
            this.getCalendarFromAPI(todayOrTom);
        } else {
            this.setState({ fireZipCheckQuery: true });
            this.calendarButtonNoZip();
        }
    }

    updatePersonalizationState = () => {
        this.setState({ personalization: { modalOpen: true } });
    }

    handleFlexClose = () => {
        const { featureFlags, variantDeliveryOptions } = this.props;
        const { todayTomArray, activeButton } = this.state;
        const today = todayTomArray?.[0]?.deliveryDate || format(new Date(), 'yyyy-MM-dd');
        const isDeliveryDateOptionsEnabled = featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled'] && variantDeliveryOptions;
        if (isDeliveryDateOptionsEnabled && activeButton === 'button1') {
            this.deliveryDateOptionsGetCalendarAPI();
        }
        if (isDeliveryDateOptionsEnabled && activeButton === 'button2') {
            this.setState({
                deliveryDateOption: today !== format(new Date(), 'yyyy-MM-dd') ? 'tomorrow' : 'today',
            });
        }
        this.setState({
            flexModalOpen: false,
            flexData: null,
            deliveryDateOptionsFlexDetails: null,
            showCalendar: true,
            deliveryDateOption: '',
        });
    }

    prepareAddToCartTodayTomorrow = () => {
        const { location, selectedSku } = this.props;
        let categoryId = null;
        let categoryName = null;
        let categoryPath = null;
        // if the user direct loads a product page there will be no categoryId
        if (location) {
            categoryPath = location.pathname;

            if (location.state) {
                const { fromCategoryPage } = location.state;

                if (fromCategoryPage) {
                    if (location.state.categoryId) {
                        categoryId = location.state.categoryId;
                    }

                    if (location.state.categoryPath) {
                        categoryPath = location.state.categoryPath;
                    }

                    if (location.state.categoryName) {
                        categoryName = location.state.categoryName;
                    }
                }
            }
        } else {
            categoryId = null;
        }

        let skipAddons = false;

        // sympathyValue: '1' - Home, '2' - Funeral
        if ((location.state && location.state.skipAddons) || (selectedSku?.sympathyValue === '1' || selectedSku?.sympathyValue === '2')) {
            skipAddons = true;
        }

        const attributes = {
            categoryId,
            categoryPath,
            categoryIdent: categoryName,
        };

        return {
            skipAddons,
            attributes,
            categoryId,
            categoryName,
            categoryPath,
        };
    }

    handleFlexDetails = (deliveryDateOptionsFlexDetails) => {
        this.setState({ deliveryDateOptionsFlexDetails, flexModalOpen: false, flexDetailsAvailable: true });
    }

    handlePickADate = (dateSelected, flexOptionSelected = {}) => {
        const { trackEvent } = this.props;
        const { todayTomArray } = this.state;
        const today = todayTomArray?.[0]?.deliveryDate || format(new Date(), 'yyyy-MM-dd');
        const todayDateChoseFromCalendar = today === dateSelected?.data?.deliveryDate;
        const selectedDateFromCalendar = dateSelected?.data?.deliveryDate;
        const reformattedSelectDateFromCalendar = selectedDateFromCalendar?.split('-').join('/');
        const formattedSelectedDate = format(new Date(reformattedSelectDateFromCalendar), 'yyyy-MM-dd');
        this.setState({
            showCalendar: false,
            calendarIsLoading: false,
            dateSelectedFromCalendar: dateSelected,
            deliveryDateOption: formattedSelectedDate,
            activeButton: 'button3',
        });
        if (todayDateChoseFromCalendar) {
            trackEvent({
                eventAction: 'Delivery Date Option - Fastest Delivery Selected From Calendar',
                eventCategory: 'Delivery Date Options',
                eventLabel: 'Delivery Date Option - Fastest Delivery Selected From Calendar',
            });
        }
        if (dateSelected?.data?.flexDetails) {
            this.getCalendarFromAPI(formattedSelectedDate);
        }
    };

    flexTodayTomorrowAddToCart = (flexDate) => {
        const { todayTomArray, startDateString } = this.state;
        const {
            actionAddToCart,
            selectedSku,
            brandId,
            history,
            locationType,
            location,
            subscriptionValues,
            userSubmittedZip,
            partNumber,
            isPassportBundleItem,
            movieSelected,
            hasWine,
            wineValidation,
            isFlowersSubscriptionFeatureEnabled,
            isFlowersTempV1SubscriptionFeatureEnabled,
            subscription,
            subscriptionDetails,
            // trackEvent,
            showWrapup,
            featureFlags,
            isPersistAddressEnabled,
            isWrapUpEnabled,
            salesforceResponseWrapUpShowHide,
            variantAddon,
            selectAddons,
        } = this.props;

        const {
            skipAddons,
            attributes,
            categoryId,
            categoryName,
            categoryPath,
        } = this.prepareAddToCartTodayTomorrow();

        const selectedDate = todayTomArray?.find((day) => day?.deliveryDate === startDateString);

        let productCode = selectedSku.id;
        let productPartNumber = partNumber;

        /* Feature - FPT / GPT - Back Up Product - Start */

        const backUpProductBrandCode = selectedDate?.backupSkuBrand;
        const backUpProductSkuCode = selectedDate?.backupSkuCode;

        const backUpProduct = checkDateHasBackUpProduct(productCode, backUpProductBrandCode, backUpProductSkuCode);

        if (backUpProduct.hasProduct) {
            productCode = backUpProduct.productCode;
            productPartNumber = backUpProduct.productCode;
        }

        /* Feature - FPT / GPT - Back Up Product - End */
        const quantity = 1;
        const delivery = {
            deliveryDate: formatDate_MM_dd_yyyy_HH_mm_ss(selectedDate.deliveryDate),
            zipCode: userSubmittedZip,
            locationType,
            deliverySLA: selectedDate.deliverySLA,
            deliveryDateType: selectedDate.calendarDateType,
        };

        if (flexDate.optionKey) {
            delivery.flexVariantId = selectedDate.flexDetails?.variantId || '';
            delivery.flexOptionKey = flexDate.optionKey;
            delivery.flexOptionId = flexDate.optionCode;
        }

        // /** supposly is inthe selectedSKUUUUUUUUUUUUU
        /**
         * Passing price rule id that will use to calculate the price dynamically based on the price rules
         */
        // if (selectedSku?.priceRules?.length) {
        //     item.priceRules = selectedSku.priceRules;
        // }

        /* Wine data - Start */
        let wineVerify = {};
        if (hasWine && wineValidation && this.getAvailability(wineValidation) && wineValidation.wineVerify) {
            wineVerify = {
                ...wineValidation.wineVerify,
            };
        }

        let subscriptionData = {};

        // subscription v1 - temporary hardcode
        if (isFlowersSubscriptionFeatureEnabled && !isFlowersTempV1SubscriptionFeatureEnabled && location?.pathname?.includes('subscription')) {
            subscriptionData = {
                isSelected: subscription?.subscriptionCheckbox,
                hasFrequencyList: featureFlags['is-subscription-frequency'],
                hasDurationList: featureFlags['is-subscription-duration'],
                duration: 1,
                interval: 30,
                type: 'Basic',
            };
        }

        if (
            isFlowersSubscriptionFeatureEnabled
            && isFlowersTempV1SubscriptionFeatureEnabled
            && subscription?.subscriptionCheckbox
            && subscriptionDetails
            && subscriptionDetails.subscriptionDurationKey
            && subscriptionDetails.subscriptionFrequency
            && subscriptionDetails.subscriptionType
        ) {
            let duration = subscriptionValues?.duration?.toString?.() || subscriptionDetails.subscriptionDurationKey;
            if (duration.indexOf('.') > 0) {
                duration = duration.substring(0, duration.indexOf('.'));
            }

            let interval = subscriptionValues?.subscriptionInterval?.toString?.() || subscriptionDetails.subscriptionFrequency;
            if (interval.indexOf('.') > 0) {
                interval = interval.substring(0, interval.indexOf('.'));
            }

            subscriptionData = {
                isSelected: subscription?.subscriptionCheckbox,
                hasFrequencyList: featureFlags['is-subscription-frequency'],
                hasDurationList: featureFlags['is-subscription-duration'],
                duration,
                interval,
                type: subscriptionDetails.subscriptionType,
            };
        }

        // if passportBundle flow; redirect to /checkout
        let passportBundle = {};
        if (isPassportBundleItem?.enable) {
            passportBundle = {
                enable: true,
                passportSku: isPassportBundleItem?.passportSku,
            };
        }

        const ATC = new AddToCartBuilderObject(
            brandId,
            productCode,
            quantity,
            [], // cyoSelectedComponents
            selectAddons, // addons
            null, // productLineItemType
            subscriptionData,
            attributes,
            wineVerify,
            {}, // personalizationLines
            {}, // pmallSummaryInfo
            {}, // giftList,
            null, // deliveryIndicatorPDP for gift list
            null, // deliveryMethod for giftlist
            null, // contactId,
            selectedSku,
            delivery,
        );

        const itemObj = ATC.getPayload();

        actionAddToCart({
            item: [itemObj],
            history,
            categoryId,
            partNumber: productPartNumber,
            categoryName,
            categoryPath,
            isMobile: false,
            eventType: 'Product Page',
            passportBundle,
            movieSelected,
            skipAddons,
            showWrapup,
            deliveryDate: selectedDate.date,
            location,
            isPersistAddressEnabled,
            isWrapUpEnabled,
            salesforceResponseWrapUpShowHide,
            variantAddon,
        });
    }

    checkIfDateExsist = (todayOrTom) => {
        const { todayTomArray, startDateString } = this.state;
        const {
            actionAddToCart,
            selectedSku,
            brandId,
            history,
            locationType,
            location,
            productDeliveryType,
            userSubmittedZip,
            partNumber,
            isPassportBundleItem,
            movieSelected,
            hasWine,
            wineValidation,
            isFlowersSubscriptionFeatureEnabled,
            isFlowersTempV1SubscriptionFeatureEnabled,
            subscription,
            subscriptionDetails,
            subscriptionValues,
            trackEvent,
            showWrapup,
            featureFlags,
            isPersistAddressEnabled,
            isWrapUpEnabled,
            salesforceResponseWrapUpShowHide,
            variantDeliveryOptions,
            variantAddon,
            selectAddons,
        } = this.props;

        const {
            skipAddons,
            attributes,
            categoryId,
            categoryName,
            categoryPath,
        } = this.prepareAddToCartTodayTomorrow();

        let doesDateMatchCalDate;
        let brandCode = brandId;
        for (let i = 0; i < todayTomArray.length; i += 1) {
            if (todayTomArray[i]?.deliveryDate === startDateString) {
                const selectedDate = todayTomArray[i];
                if (selectedDate.flexDetails) {
                    const flexTaggingData = {
                        zipcode: userSubmittedZip,
                        delierytype: productDeliveryType,
                        date: format(new Date(selectedDate.deliveryDate?.split('-')?.join('/')), 'yyyy-MM-dd'),
                    };
                    this.setState({
                        flexModalOpen: true,
                        flexData: selectedDate.flexDetails.option,
                        flexTaggingData,
                        calendarIsLoading: false,
                    });
                    return;
                }
                doesDateMatchCalDate = true;

                let productCode = selectedSku.id;
                let productPartNumber = partNumber;

                /* Feature - FPT / GPT - Back Up Product - Start */

                const backUpProductBrandCode = selectedDate?.backupSkuBrand;
                const backUpProductSkuCode = selectedDate?.backupSkuCode;

                const backUpProduct = checkDateHasBackUpProduct(productCode, backUpProductBrandCode, backUpProductSkuCode);

                if (backUpProduct.hasProduct) {
                    brandCode = backUpProductBrandCode;
                    productCode = backUpProduct.productCode;
                    productPartNumber = backUpProduct.productCode;
                }
                /* Feature - FPT / GPT - Back Up Product - End */
                const quantity = 1;
                const delivery = {
                    deliveryDate: formatDate_MM_dd_yyyy_HH_mm_ss(selectedDate.deliveryDate),
                    zipCode: userSubmittedZip,
                    locationType,
                    deliverySLA: selectedDate.deliverySLA,
                    deliveryDateType: selectedDate.calendarDateType,
                };

                // /** supposly is inthe selectedSKUUUUUUUUUUUUU
                /**
                 * Passing price rule id that will use to calculate the price dynamically based on the price rules
                 */
                // if (selectedSku?.priceRules?.length) {
                //     item.priceRules = selectedSku.priceRules;
                // }

                /* Wine data - Start */
                let wineVerify = {};
                if (hasWine && wineValidation && this.getAvailability(wineValidation) && wineValidation.wineVerify) {
                    wineVerify = {
                        ...wineValidation.wineVerify,
                    };
                }

                let subscriptionData = {};

                // subscription v1 - temporary hardcode
                if (isFlowersSubscriptionFeatureEnabled && !isFlowersTempV1SubscriptionFeatureEnabled && location?.pathname?.includes('subscription')) {
                    subscriptionData = {
                        isSelected: subscription?.subscriptionCheckbox,
                        hasFrequencyList: featureFlags['is-subscription-frequency'],
                        hasDurationList: featureFlags['is-subscription-duration'],
                        duration: 1,
                        interval: 30,
                        type: 'Basic',
                    };
                }

                if (isFlowersSubscriptionFeatureEnabled && isFlowersTempV1SubscriptionFeatureEnabled
                    && subscription?.subscriptionCheckbox
                    && subscriptionDetails
                    && subscriptionDetails.subscriptionDurationKey
                    && subscriptionDetails.subscriptionFrequency
                    && subscriptionDetails.subscriptionType) {
                    let duration = subscriptionValues?.duration?.toString?.() || subscriptionDetails.subscriptionDurationKey;
                    if (duration.indexOf('.') > 0) {
                        duration = duration.substring(0, duration.indexOf('.'));
                    }

                    let interval = subscriptionValues?.subscriptionInterval?.toString?.() || subscriptionDetails.subscriptionFrequency;
                    if (interval.indexOf('.') > 0) {
                        interval = interval.substring(0, interval.indexOf('.'));
                    }

                    subscriptionData = {
                        isSelected: subscription?.subscriptionCheckbox,
                        hasFrequencyList: featureFlags['is-subscription-frequency'],
                        hasDurationList: featureFlags['is-subscription-duration'],
                        duration,
                        interval,
                        type: subscriptionValues?.subscriptionType || subscriptionDetails.subscriptionType,
                    };
                }

                // if passportBundle flow; redirect to /checkout
                let passportBundle = {};
                if (isPassportBundleItem?.enable) {
                    passportBundle = {
                        enable: true,
                        passportSku: isPassportBundleItem?.passportSku,
                    };
                }

                const ATC = new AddToCartBuilderObject(
                    brandCode,
                    productCode,
                    quantity,
                    [], // cyoSelectedComponents
                    selectAddons, // addons
                    null, // productLineItemType
                    subscriptionData,
                    attributes,
                    wineVerify,
                    {}, // personalizationLines
                    {}, // pmallSummaryInfo
                    {}, // giftList,
                    null, // deliveryIndicatorPDP for gift list
                    null, // deliveryMethod for giftlist
                    null, // contactId,
                    selectedSku,
                    delivery,
                );

                const itemObj = ATC.getPayload();

                trackEvent({
                    eventCategory: 'Product Page',
                    eventAction: `Add to Cart - ${todayOrTom}`,
                    eventLabel: productCode,
                });

                actionAddToCart({
                    item: [itemObj],
                    history,
                    categoryId,
                    partNumber: productPartNumber,
                    categoryName,
                    categoryPath,
                    isMobile: false,
                    eventType: 'Product Page',
                    passportBundle,
                    movieSelected,
                    skipAddons,
                    showWrapup,
                    deliveryDate: selectedDate.date,
                    location,
                    isPersistAddressEnabled,
                    isWrapUpEnabled,
                    salesforceResponseWrapUpShowHide,
                    variantAddon,
                });
                break;
            }
        }

        if (!doesDateMatchCalDate) {
            let todayTomDateNotAvailText = 'Today or tomorrow is no longer available for this zip. Please select a new date';
            if (todayOrTom === 'today') {
                todayTomDateNotAvailText = 'Today is no longer available for this zip. Please select a new date';
            } else if (todayOrTom === 'tomorrow') {
                todayTomDateNotAvailText = 'Tomorrow is no longer available for this zip. Please select a new date';
            }
            this.setState({
                todayTomDateNotAvailText,
            });
            this.submitUserSelectedZipcode();
            this.handleCalendarModal();
            this.setCalendarDataLoadingFlag(
                true,
            );
        }
        this.setState({
            calendarIsLoading: false,
        });
    }

    generateTodayTomState = (todayTomCalendarDates, startDate, todayOrTom) => {
        const { featureFlags, variantDeliveryOptions } = this.props;
        const isDeliveryDateOptionsEnabled = featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled'] && variantDeliveryOptions;
        const formattedDate = todayOrTom === 'today' || todayOrTom === 'tomorrow' ? format(getNow(todayOrTom), 'yyyy-MM-dd') : todayOrTom;
        this.setState({
            todayTomArray: todayTomCalendarDates,
            startDateString: isDeliveryDateOptionsEnabled ? formattedDate : startDate,
        },
        () => { this.checkIfDateExsist(todayOrTom); });
    }

    isInternationalProduct = () => {
        const { selectedSku } = this.props;
        return selectedSku?.isInternational || false;
    }

    simpleAddToCart = (returnObject = false) => {
        // this add to cart is used when an 18F user views a product for a brand that does
        // not display delivery calendar on pdp
        const { personalization } = this.state;
        const {
            actionAddToCart, selectedSku, brandId, history, partNumber, categoryId, categoryName, categoryPath,
            subscriptionDetails, subscription, isFlowersSubscriptionFeatureEnabled, isFlowersTempV1SubscriptionFeatureEnabled, selectAddons,
            pmallSummaryInfo, featureFlags, isPassportBundleProduct, productCategories, isWrapUpEnabled, salesforceResponseWrapUpShowHide, isPersistAddressEnabled, variantAddon,
        } = this.props;

        let productCode = selectedSku.id;
        if (productCode?.indexOf('-') >= 0) {
            productCode = productCode.split('-');
            productCode = productCode[productCode.length - 1];
        }

        const reqObj = {
            brandCode: brandId,
            productCode,
            quantity: 1,
            attributes: [],
        };

        // handling attributes
        if (categoryId) {
            reqObj.attributes.push({
                attributeName: 'categoryId',
                attributeValue: categoryId,
            });
        }
        if (categoryPath) {
            reqObj.attributes.push({
                attributeName: 'categoryPath',
                attributeValue: categoryPath,
            });
        }

        if (categoryName) {
            reqObj.attributes.push({
                attributeName: 'categoryIdent',
                attributeValue: categoryName,
            });
        }

        /**
         * Passing price rule id that will use to calculate the price dynamically based on the price rules
         */
        if (selectedSku?.priceRules?.length) {
            reqObj.priceRules = selectedSku.priceRules;
        }

        let personalizationLines;
        if (personalization?.lineState) {
            personalizationLines = personalization.lineState?.map((line, i) => ({
                perAttributeId: `${i + 1}`,
                perAttributeValue: personalization.lineState[i].lineText,
            }));
        }

        /**
             * Handle req object personlization fields
             * for internal products
             */
        if (personalizationLines) {
            reqObj.personalization = {
                personalizationType: 'PRODUCT_PERSONALIZATION',
                personalizationLines,
            };
        }

        if (selectedSku.productType === 'CLUB' || selectedSku.productType === 'COLLECTION') {
            reqObj.lineItemType = selectedSku.productType;
        }

        // The products only needs firstname, lastname and email,
        // without send emails at the end of place order (example: market place vendor)
        if (
            selectedSku?.parentProduct?.categories?.includes('digital_delivery')
            || productCategories?.includes('digital_delivery')
        ) {
            reqObj.lineItemType = 'DDELVR';
        }

        let skipAddons = false;
        if (
            selectedSku?.parentProduct?.categories?.includes('donations')
            || productCategories?.includes('donations')
        ) {
            skipAddons = true;
        }

        // The product when is NBCU
        if (
            selectedSku?.parentProduct?.categories?.includes('digital_products')
            || selectedSku?.name?.toLowerCase()?.includes('digital movie gift')
            || productCategories?.includes('digital_products')
        ) {
            reqObj.lineItemType = 'NBCU';
        }

        if (featureFlags['is-pmall-enabled'] && pmallSummaryInfo?.customizations?.refnum) {
            const pmallLines = [
                {
                    perAttributeId: 'description',
                    perAttributeValue: pmallSummaryInfo.customizations.description,
                },
                {
                    perAttributeId: 'previewUrl',
                    perAttributeValue: pmallSummaryInfo.customizations.imageURL,
                },
            ];

            reqObj.personalization = {
                personalizationType: 'EXTERNAL',
                personalizationId: pmallSummaryInfo.customizations.refnum,
                personalizationLines: pmallLines,
            };

            if (pmallSummaryInfo?.customizations?.addonCount) {
                reqObj.personalization.addonCount = pmallSummaryInfo.customizations.addonCount;
            }
        }

        if (isFlowersSubscriptionFeatureEnabled && isFlowersTempV1SubscriptionFeatureEnabled
            && subscription?.subscriptionCheckbox
            && subscriptionDetails
            && subscriptionDetails.subscriptionDurationKey
            && subscriptionDetails.subscriptionFrequency
            && subscriptionDetails.subscriptionType) {
            let duration = subscriptionDetails.subscriptionDurationKey;
            if (duration.indexOf('.') > 0) {
                duration = duration.substring(0, duration.indexOf('.'));
            }

            let interval = subscriptionDetails.subscriptionFrequency;
            if (interval.indexOf('.') > 0) {
                interval = interval.substring(0, interval.indexOf('.'));
            }

            reqObj.subscription = {
                duration,
                interval,
                type: subscriptionDetails.subscriptionType,
            };
        }
        if (selectAddons?.length > 0) {
            reqObj.components.addons = selectAddons;
        }

        if (returnObject) {
            return {
                reqObj,
                history,
                partNumber,
                categoryId,
                categoryName,
                categoryPath,
                skipAddons,
            };
        }

        actionAddToCart({
            item: [reqObj],
            history,
            categoryId,
            partNumber,
            categoryName,
            categoryPath,
            enableMinicart: false,
            isMobile: false,
            eventType: 'Product Page',
            passportBundle: isPassportBundleProduct,
            skipAddons,
            isPersistAddressEnabled,
            isWrapUpEnabled,
            salesforceResponseWrapUpShowHide,
            variantAddon,
        });

        return null;
    };

    deliveryDateOptionsGetCalendarAPI = async () => {
        const startDate = format(getNow('today'), 'yyyy-MM-dd');

        const {
            locationType,
            validatedZip,
            auth,
            selectedSku,
            brandId,
            isAuthenticated,
            passportInCart,
            isPassportUser,
            featureFlags,
        } = this.props;

        const jwt = await auth.getAccessTokenSafely();

        // Starting at the end of the string (backwards pattern matching), continue to match any characters that aren't '-' or '_'
        const itemSku = selectedSku.id.match(/[^-_]*$/);
        let customerType = isAuthenticated ? 'R' : 'G';
        if (passportInCart || (isAuthenticated && isPassportUser)) {
            customerType = 'P';
        }

        getDeliveryCalendarByProduct(
            {},
            jwt,
            itemSku,
            brandId,
            validatedZip,
            locationType,
            startDate,
            customerType,
            undefined,
            featureFlags['is-new-flex-flows-enabled'],
        )
            .then(({ data }) => {
                if (data.response.calendarDates.length === 0) {
                    this.submitUserSelectedZipcode();
                    this.handleDeliveryAvailability(false);
                    this.setState({
                        todayTomArray: [],
                        startDateString: '',
                    });
                    return;
                }
                this.setState({ productIsNotAvailable: false });
                const totalSurchargeToday = (Number(data.response.calendarDates[0].surcharge || 0) + Number(data.response.calendarDates[0].upcharge || 0)).toFixed(2);
                const totalSurchargeTomorrow = (Number(data.response.calendarDates[1].surcharge || 0) + Number(data.response.calendarDates[1].upcharge || 0)).toFixed(2);
                const isFlexDate = data.response.calendarDates[1].flexDetails;
                const isTodayFlexDate = data.response.calendarDates[0].flexDetails;
                const firstElementWithoutSurcharge = data.response.calendarDates.find((date) => date.surcharge === '0.00' && date.upcharge === '0.0' && !date.flexDetails);
                let firstElementAfterSecond;
                if (totalSurchargeTomorrow !== '0.00' || isFlexDate) {
                    firstElementAfterSecond = data.response.calendarDates.slice(2).find((date) => date.surcharge === '0.00' && date.upcharge === '0.0' && !date.flexDetails);
                }
                const firstElementWithSurcharge = data.response.calendarDates.find((date) => date.surcharge !== '0.00' || date.upcharge !== '0.0' || date.flexDetails);
                const showButtonWithSurcharge = firstElementWithSurcharge || data.response.calendarDates[0];
                if (!firstElementWithSurcharge) {
                    this.setState({ dateWithSurchargeAvailable: false });
                }
                if (!data.response.calendarDates.find((date) => date.surcharge === '0.00' && date.upcharge === '0.0' && !date.flexDetails)) {
                    this.setState({ dateWithoutSurchargeAvailable: false });
                }
                const firstOptionDate = totalSurchargeTomorrow !== '0.00' || isFlexDate ? firstElementAfterSecond : firstElementWithoutSurcharge;
                const secondOptionDate = totalSurchargeToday !== '0.00' || isTodayFlexDate ? data.response.calendarDates[0] : showButtonWithSurcharge;
                const todayTomCalendarDates = [secondOptionDate, firstOptionDate];
                const standardOptionDate = firstOptionDate.deliveryDate;
                const tomorrowDateSelected = standardOptionDate.split('-').join('/');
                const formattedTomorrowDate = format(new Date(tomorrowDateSelected), 'yyyy-MM-dd');
                const FastestOptionDate = secondOptionDate?.deliveryDate;
                const todayDateSelected = FastestOptionDate?.split('-').join('/');
                const secondButtonDate = data.response.calendarDates[0].deliveryDate.split('-').join('/');
                const formattedFirstOptionDate = totalSurchargeTomorrow === '0.00' || !isFlexDate ? format(new Date(todayDateSelected), 'eee, M/d') : format(new Date(secondButtonDate), 'eee, M/d');
                const formattedSecondOptionDate = format(new Date(tomorrowDateSelected), 'eee, M/d');

                this.setState({
                    todayTomArray: todayTomCalendarDates,
                    deliveryDateOption: formattedTomorrowDate,
                    optionOneDate: formattedFirstOptionDate,
                    optionTwoDate: formattedSecondOptionDate,
                });
            })
            .catch((err) => {
                this.setState({ productIsNotAvailable: true });
                mbpLogger.logError({
                    appName: process.env.npm_package_name,
                    component: 'GraphqlPDPCalendar',
                    apiCall: 'getDeliveryCalendarByProduct',
                    jsError: err,
                    jwt,
                    itemSku,
                    brandId,
                    validatedZip,
                    locationType,
                    startDate,
                    customerType,
                });
            });
    }

    getCalendarFromAPI = async (todayOrTom) => {
        const {
            locationType,
            validatedZip,
            auth,
            selectedSku,
            brandId,
            isAuthenticated,
            passportInCart,
            isPassportUser,
            featureFlags,
            variantDeliveryOptions,
        } = this.props;
        const isDeliveryDateOptionsEnabled = featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled'] && variantDeliveryOptions;
        this.setState({
            calendarIsLoading: true,
        });
        let startDate;
        startDate = format(getNow(todayOrTom), 'yyyy-MM-dd');
        if (isDeliveryDateOptionsEnabled) {
            startDate = format(getNow('today'), 'yyyy-MM-dd');
            if (todayOrTom === 'tomorrow') {
                startDate = format(getNow('tomorrow'), 'yyyy-MM-dd');
            }
        }

        const jwt = await auth.getAccessTokenSafely();

        // Starting at the end of the string (backwards pattern matching), continue to match any characters that aren't '-' or '_'
        const itemSku = selectedSku.id.match(/[^-_]*$/);
        let customerType = isAuthenticated ? 'R' : 'G';
        if (passportInCart || (isAuthenticated && isPassportUser)) {
            customerType = 'P';
        }

        getDeliveryCalendarByProduct(
            {},
            jwt,
            itemSku,
            brandId,
            validatedZip,
            locationType,
            startDate,
            customerType,
            undefined,
            featureFlags['is-new-flex-flows-enabled'],
        )
            .then(({ data }) => {
                if (data.response.calendarDates.length === 0) {
                    this.submitUserSelectedZipcode();
                    this.handleDeliveryAvailability(false);
                    this.setState({
                        todayTomArray: [],
                        startDateString: '',
                    });
                    return;
                }
                const totalSurchargeToday = (Number(data.response.calendarDates[0].surcharge || 0) + Number(data.response.calendarDates[0].upcharge || 0)).toFixed(2);
                const totalSurchargeTomorrow = (Number(data.response.calendarDates[1].surcharge || 0) + Number(data.response.calendarDates[1].upcharge || 0)).toFixed(2);
                const isFlexDate = data.response.calendarDates[1].flexDetails;
                const isTodayFlexDate = data.response.calendarDates[0].flexDetails;
                let firstElementAfterSecond;
                let firstElementWithSurcharge;
                if (totalSurchargeTomorrow !== '0.00' || isFlexDate) {
                    firstElementAfterSecond = data.response.calendarDates.slice(2).find((date) => date.surcharge === '0.00' && date.upcharge === '0.0' && !date.flexDetails);
                }
                if (totalSurchargeToday === '0.00' || !isFlexDate) {
                    firstElementWithSurcharge = data.response.calendarDates.find((date) => date.surcharge !== '0.00' || date.upcharge !== '0.0' || date.flexDetails);
                }
                const firstOptionDate = totalSurchargeTomorrow !== '0.00' || isFlexDate ? firstElementAfterSecond : data.response.calendarDates[1];
                const secondOptionDate = totalSurchargeToday === '0.00' || isTodayFlexDate ? firstElementWithSurcharge : data.response.calendarDates[0];
                const dateSelectedFromCalendar = data.response.calendarDates.find((date) => date.deliveryDate === todayOrTom);
                const todayTomCalendarDates = isDeliveryDateOptionsEnabled ? [secondOptionDate, firstOptionDate, dateSelectedFromCalendar] : [data.response.calendarDates[0], data.response.calendarDates[1]];
                this.generateTodayTomState(todayTomCalendarDates, startDate, todayOrTom);
            })
            .catch((err) => {
                this.handleDeliveryAvailability(false);
                mbpLogger.logError({
                    appName: process.env.npm_package_name,
                    component: 'GraphqlPDPCalendar',
                    apiCall: 'getDeliveryCalendarByProduct',
                    jsError: err,
                    jwt,
                    itemSku,
                    brandId,
                    validatedZip,
                    locationType,
                    startDate,
                    customerType,
                });
            });
    };

    handleAgeVerify = (handleMobileAgeVerification, hasWine) => {
        const { displayDeliveryCalendar } = this.props;
        if (hasWine && !displayDeliveryCalendar) {
            handleMobileAgeVerification(true, this.fullCalendarCall(true));
        } else {
            this.fullCalendarCall();
        }
    };

    fullCalendarCall = (returnObject = false) => {
        const { gptSkipCalendarVariantFlowEnabled } = this.state;
        const {
            validatedZip, userSubmittedZip, trackEvent, selectedSku, displayDeliveryCalendar, location, featureFlags, productSkus, partNumber,
        } = this.props;
        const subscriptionProduct = location.search.includes('subscription');
        const { zipField, todayTomDateNotAvailText } = this.state;
        this.setState({ fireCalendarQuery: true });
        let returnVal = null;
        if (!displayDeliveryCalendar || featureFlags['is-zip-override-fallback-enabled'] || gptSkipCalendarVariantFlowEnabled) {
            if (returnObject) {
                returnVal = this.simpleAddToCart(true);
                return returnVal;
            }
            if (selectedSku.personalization?.lines?.length && selectedSku.personalization?.indicator && selectedSku.personalization.indicator !== '0') {
                // if the item requires personalization then pause the execution of this function and open
                // personalization modal
                this.setState({ personalization: { modalOpen: true } });
                return returnVal;
            }
            if (productSkus[0].ageVerifyFlag === 'true') {
                this.setState({
                    showAgeVerification: true,
                });
                return returnVal;
            }
            this.simpleAddToCart();
            return returnVal;
        }
        trackEvent({
            eventCategory: subscriptionProduct ? 'subscription' : 'Product Page',
            eventAction: subscriptionProduct ? 'conversion' : 'Purchasing Option',
            eventLabel: subscriptionProduct ? getBaseCode(partNumber) : 'One Time',
            eventValue: '1',
        });
        if (this.isInternationalProduct()) {
            trackEvent({ eventCategory: 'Product Page', eventAction: 'Delivery Option Selected', eventLabel: 'More Dates' });
            this.handleCalendarModal();
            this.setCalendarDataLoadingFlag(true);
        } else if ((validatedZip !== '' && validatedZip === zipField) || (userSubmittedZip !== '' && zipField === userSubmittedZip)) {
            trackEvent({ eventCategory: 'Product Page', eventAction: 'Delivery Option Selected', eventLabel: 'More Dates' });
            this.submitUserSelectedZipcode();
            if (selectedSku.personalization?.lines?.length && selectedSku.personalization?.indicator && selectedSku.personalization.indicator !== '0') {
                // if the item requires personalization then pause the execution of this function and open
                // personalization modal
                this.setState({ personalization: { modalOpen: true } });
                return returnVal;
            }
            this.handleCalendarModal();
            this.setCalendarDataLoadingFlag(true);
            if (todayTomDateNotAvailText !== '') {
                this.setState({
                    todayTomDateNotAvailText: '',
                });
            }
        } else {
            this.setState({ fireZipCheckQuery: true });
            this.calendarButtonNoZip();
        }
        return returnVal;
    };

    handlePersonalizationTextFieldChange = (e) => {
        const { personalization } = this.state;
        const stateCopy = personalization;
        if (e.target.value.length <= stateCopy.lineState[Number(e.target.name)].maxChars) {
            // this condition is check and ensure the user does not enter a space as the first character
            if (e.target.value.substring(0, 1) !== ' ') {
                stateCopy.lineState[e.target.name].lineText = e.target.value;
            }
        }
        this.setState({
            personalization: stateCopy,
        });
    }

    handlePersonalizationModalSubmit = () => {
        const {
            personalization,
            gptSkipCalendarVariantFlowEnabled,
            deliveryDateOption,
            personalizationAdded,
        } = this.state;
        const { displayDeliveryCalendar, featureFlags, variantDeliveryOptions } = this.props;
        const newPersonalizationState = { ...personalization, modalOpen: false };
        const isDeliveryDateOptionsEnabled = featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled'] && variantDeliveryOptions;
        this.setState({
            personalization: newPersonalizationState,
            calendarIsLoading: true,
        });
        if (!displayDeliveryCalendar || featureFlags['is-zip-override-fallback-enabled'] || gptSkipCalendarVariantFlowEnabled) {
            // if do not want to show calendar then after personalization step directly add to cart
            this.simpleAddToCart();
        }
        if (isDeliveryDateOptionsEnabled && deliveryDateOption !== 'Pick a Date' && !personalizationAdded) {
            this.addTodayOrTomToCart(deliveryDateOption);
        } else {
            this.handleCalendarModal();
        }
    }

    setPersonalizationState = (newState) => {
        this.setState({
            personalization: newState,
        });
    }

    closePersonalizationModal = () => {
        const { featureFlags, variantDeliveryOptions } = this.props;
        const { todayTomArray, activeButton } = this.state;
        const today = todayTomArray?.[0]?.deliveryDate || format(new Date(), 'yyyy-MM-dd');
        const isDeliveryDateOptionsEnabled = featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled'] && variantDeliveryOptions;
        if (isDeliveryDateOptionsEnabled && activeButton === 'button1') {
            this.deliveryDateOptionsGetCalendarAPI();
            this.setState({ personalizationAdded: false });
        }
        if (isDeliveryDateOptionsEnabled && activeButton === 'button2') {
            this.setState({
                deliveryDateOption: today !== format(new Date(), 'yyyy-MM-dd') ? 'tomorrow' : 'today',
                personalizationAdded: false,
            });
        }
        this.setState({
            personalization: { modalOpen: false },
            personalizationAdded: false,
        });
    }

    // had to add from DeliveryForm.js
    handleRemoveAddressBook = (addressBookEntryId) => {
        const {
            userType,
            callRemoveAddressBook,
        } = this.props;
        if (userType === 'R' && addressBookEntryId) {
            callRemoveAddressBook(addressBookEntryId);
        }
    }

    handleSelectedAddressBook = (data) => {
        const {
            setLocation, setFilterZip, setSelectedAddress, userSubmittedZip, clearFilterZip, setZipcodeValidity, setValZip,
        } = this.props;
        if (userSubmittedZip) {
            clearFilterZip();
        }

        const addressComponents = data?.addresses[0] || {};
        const postalCode = (addressComponents.zip) ? addressComponents.zip.split('-')[0] : '';

        setLocation(addressComponents?.addressType || 'Residence');
        addressComponents.employerName = addressComponents?.employerName || '';
        addressComponents.firstName = addressComponents?.firstName || '';
        addressComponents.lastName = addressComponents?.lastName || '';
        if (data?.phoneNumber) {
            addressComponents.phoneNumber = data.phoneNumber;
        }
        this.setState({
            zipField: postalCode,
        }, () => {
            setValZip(postalCode);
            setZipcodeValidity(true);
            setFilterZip(postalCode.trimEnd());
        });
        const reduxAddress = {
            addressComponents,
            addressSource: 'pdpAddressBook',
        };
        setSelectedAddress(reduxAddress);
    }

    renderZipVerificationSvg = () => {
        const {
            classes, userSubmittedZip, zipValid,
        } = this.props;
        const { zipField } = this.state;
        return (
            <Typography component="div" align="left" className={classes.labelPay}>
                {((zipValid === true && zipField.length >= 5) || (userSubmittedZip !== '' && zipField === userSubmittedZip)) && (
                    <div className={classes.checkMarkContainer}>
                        <svg
                            className={classes.checkmark}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 52 52"
                        >
                            <circle className={classes.checkmarkCircle} cx="26" cy="26" r="25" fill="none" />
                            <path className={classes.checkmarkCheck} fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                        </svg>
                    </div>
                )}
            </Typography>
        );
    }

    handleDeliveryOptionsTracking = (optionClicked) => {
        const { trackEvent } = this.props;
        trackEvent({
            eventAction: `Delivery Date Option - ${optionClicked}`,
            eventCategory: 'Delivery Date Options',
            eventLabel: `Clicked-Delivery Date Option - ${optionClicked}`,
        });
    }

    deliveryDateOptionsCopy = () => {
        const { zipField } = this.state;
        const { userSubmittedZip, zipValid, classes } = this.props;
        if (
            (zipValid === true && zipField.length >= 5)
            || (userSubmittedZip !== '' && zipField === userSubmittedZip)
        ) {
            return  <p className={classes.deliveryDateOptionsCopy}>Standard shipping charge calculated at checkout</p>;
        }
        return <p className={classes.deliveryDateOptionsCopy}>Enter ZIP Code to see estimated delivery dates</p>;
    }

    handleDeliveryDateOptionSelected = (todayOrTomorrow, today, tomorrow, buttonId) => {
        const { zipValid, userSubmittedZip, selectedSku } = this.props;
        const { zipField, productIsNotAvailable } = this.state;
        if (todayOrTomorrow === 'today') {
            if (productIsNotAvailable) {
                return this.fullCalendarCall();
            }
            // after the daily cuttoff time render tomorrow date
            return this.setState({
                deliveryDateOption: today !== format(new Date(), 'yyyy-MM-dd') ? today : 'today',
                activeButton: buttonId,
                personalizationAdded: false,
                flexDetailsAvailable: false,
            });
        }

        if (todayOrTomorrow === 'tomorrow') {
            const tomorrowDate = tomorrow !== format(addDays(new Date(), 1), 'yyyy-MM-dd') ? tomorrow : format(addDays(new Date(), 1), 'yyyy-MM-dd');
            const tomorrowDateSelected = tomorrowDate && tomorrowDate?.split('-').join('/');
            const formattedTomorrowDate = tomorrowDateSelected && format(new Date(tomorrowDateSelected), 'yyyy-MM-dd');
            if (productIsNotAvailable) {
                return this.fullCalendarCall();
            }
            // after the daily cuttoff time render day after tomorrow date
            return  this.setState({
                deliveryDateOption: tomorrow !== format(addDays(new Date(), 1), 'yyyy-MM-dd') ? formattedTomorrowDate : tomorrow,
                activeButton: buttonId,
                personalizationAdded: false,
                flexDetailsAvailable: false,
            });
        }

        if (todayOrTomorrow === 'Pick a Date') {
            if (!((zipValid === true && zipField.length >= 5) || (userSubmittedZip !== '' && zipField === userSubmittedZip))) {
                this.setState({ activeButton: buttonId });
            }
            this.fullCalendarCall();
            if (selectedSku.personalization?.lines?.length && selectedSku.personalization?.indicator && selectedSku.personalization.indicator !== '0') {
                // if the item requires personalization then pause the execution of this function and open
                // personalization modal
                this.setState({ personalizationAdded: true  });
            }
            return  this.setState({ deliveryDateOption: 'Pick a Date', flexDetailsAvailable: false });
        }

        if (todayOrTomorrow !== 'today' || todayOrTomorrow !== 'tomorrow' || todayOrTomorrow !== 'Pick a Date' || todayOrTomorrow !== '') {
            return  this.setState({ deliveryDateOption: format(addDays(new Date(), 2), 'yyyy-MM-dd'), personalizationAdded: false, flexDetailsAvailable: false });
        }

        return this.setState({ deliveryDateOption: '' });
    }

    deliveryDateOptionButtons = () => {
        const {
            zipField,
            todayTomArray,
            dateSelectedFromCalendar,
            activeButton,
            optionOneDate,
            optionTwoDate,
            dateWithoutSurchargeAvailable,
            dateWithSurchargeAvailable,
            deliveryDateOptionsFlexDetails,
            productIsNotAvailable,
        } = this.state;
        const {
            classes,
            userSubmittedZip,
            zipValid,
            partNumber,
            featureFlags,
            location,
            validVaseConfiguratorSku,
        } = this.props;
        let reformattedFlexRangeStartDate;
        let reformattedFlexRangeEndDate;
        let secondButtonFlexRangeStartDate;
        let secondButtonFlexRangeEndDate;
        let firstButtonFlexRangeStartDate;
        let firstButtonFlexRangeEndDate;
        if (dateSelectedFromCalendar?.data?.flexDetails) {
            const flexRangeStartDate = deliveryDateOptionsFlexDetails && deliveryDateOptionsFlexDetails?.rangeStartDate;
            const flexRangeEndDate = deliveryDateOptionsFlexDetails && deliveryDateOptionsFlexDetails?.rangeEndDate;
            const reformattedRangeStartDate = format(new Date(flexRangeStartDate), 'yyyy-MM-dd');
            const reformattedRangeEndDate = format(new Date(flexRangeEndDate), 'yyyy-MM-dd');
            reformattedFlexRangeStartDate = reformattedRangeStartDate?.split('-').join('/');
            reformattedFlexRangeEndDate = reformattedRangeEndDate?.split('-').join('/');
        }
        if (todayTomArray?.[0]?.flexDetails) {
            const flexRangeStartDate = todayTomArray?.[0]?.flexDetails?.option?.[0]?.rangeStartDate;
            const flexRangeEndDate = todayTomArray?.[0]?.flexDetails?.option?.[0]?.rangeEndDate;
            const reformattedRangeStartDate = format(new Date(flexRangeStartDate), 'yyyy-MM-dd');
            const reformattedRangeEndDate = format(new Date(flexRangeEndDate), 'yyyy-MM-dd');
            secondButtonFlexRangeStartDate = reformattedRangeStartDate?.split('-').join('/');
            secondButtonFlexRangeEndDate = reformattedRangeEndDate?.split('-').join('/');
        }
        if (todayTomArray?.[1]?.flexDetails) {
            const flexRangeStartDate = todayTomArray?.[0]?.flexDetails?.flexDetails?.option?.[0]?.rangeStartDate;
            const flexRangeEndDate = todayTomArray?.[0]?.flexDetails?.flexDetails?.option?.[0]?.rangeEndDate;
            const reformattedRangeStartDate = format(new Date(flexRangeStartDate), 'yyyy-MM-dd');
            const reformattedRangeEndDate = format(new Date(flexRangeEndDate), 'yyyy-MM-dd');
            firstButtonFlexRangeStartDate = reformattedRangeStartDate?.split('-').join('/');
            firstButtonFlexRangeEndDate = reformattedRangeEndDate?.split('-').join('/');
        }
        const isVaseConfiguratorProduct = featureFlags['is-vase-configurator-enabled'] && isVaseConfigProduct(partNumber);
        const today = todayTomArray && todayTomArray?.[0]?.deliveryDate;
        const tomorrow = todayTomArray && todayTomArray?.[1]?.deliveryDate;
        const pickADate = dateSelectedFromCalendar?.data?.deliveryDate || format(new Date(), 'yyyy-MM-dd');
        // this formatting is needed to avoid the invalid date error
        const todayDate = today && today.split('-').join('/');
        const tomorrowDate = tomorrow && tomorrow.split('-').join('/');
        const pickedDate = pickADate.split('-').join('/');
        const formattedTodayDate = todayDate && format(new Date(todayDate), 'M/d');
        const formattedTomorrowDate = tomorrow === format(addDays(new Date(), 1), 'yyyy-MM-dd') ? format(new Date(tomorrowDate), 'eee, M/d') : format(addDays(new Date(), 2), 'eee, M/d');
        const formattedPickedDate = dateSelectedFromCalendar?.data?.flexDetails && reformattedFlexRangeStartDate !== '1969/12/31' && reformattedFlexRangeStartDate !== reformattedFlexRangeEndDate && activeButton === 'button3' ? `${format(new Date(reformattedFlexRangeStartDate), 'M/d')} - ${format(new Date(reformattedFlexRangeEndDate), 'M/d')}` : format(new Date(pickedDate), 'M/d');
        let totalSurchargeToday = (Number(todayTomArray?.[0]?.surcharge || 0) + Number(todayTomArray?.[0]?.upcharge || 0)).toFixed(2);
        if (todayTomArray?.[0]?.flexDetails) {
            const maxSurcharge = Math.max(...todayTomArray?.[0]?.flexDetails?.option.map((o) => Number(o.flexAmount)));
            totalSurchargeToday = maxSurcharge.toFixed(2);
            if (deliveryDateOptionsFlexDetails && deliveryDateOptionsFlexDetails.flexAmount === '0') {
                totalSurchargeToday = '0.00';
            }
        }
        const totalSurchargeTomorrow = (Number(todayTomArray?.[1]?.surcharge || 0) + Number(todayTomArray?.[1]?.upcharge || 0)).toFixed(2);
        let totalSurchargePickedDate = (Number(dateSelectedFromCalendar?.data?.surcharge || 0) + Number(dateSelectedFromCalendar?.data?.upcharge || 0)).toFixed(2);
        if (dateSelectedFromCalendar?.data?.flexDetails) {
            const pickedDateMaxSurcharge = deliveryDateOptionsFlexDetails && Number(deliveryDateOptionsFlexDetails?.flexAmount);
            totalSurchargePickedDate = pickedDateMaxSurcharge?.toFixed(2);
            if (deliveryDateOptionsFlexDetails && deliveryDateOptionsFlexDetails.flexAmount === '0') {
                totalSurchargePickedDate = '0.00';
            }
        }
        const showTodayDate = today === format(new Date(), 'yyyy-MM-dd') ? `Today, ${formattedTodayDate}` : optionOneDate;
        const showDateForSecondButton = (todayTomArray?.[0]?.flexDetails || secondButtonFlexRangeStartDate !== undefined) && (deliveryDateOptionsFlexDetails && deliveryDateOptionsFlexDetails.rangeStartDate !== deliveryDateOptionsFlexDetails.rangeEndDate) && activeButton === 'button2' ? `${format(new Date(secondButtonFlexRangeStartDate), 'M/d')} - ${format(new Date(secondButtonFlexRangeEndDate), 'M/d')}` : showTodayDate;
        const showDateForFirstButton = todayTomArray?.[1]?.flexDetails || firstButtonFlexRangeStartDate !== undefined ? `${format(new Date(firstButtonFlexRangeStartDate), 'M/d')} - ${format(new Date(firstButtonFlexRangeEndDate), 'M/d')}` : optionTwoDate;
        const showPickADate = format(new Date(pickedDate), 'yyyy-MM-dd') === format(new Date(), 'yyyy-MM-dd') ? 'Pick a Date' : formattedPickedDate;
        const showTodaySurcharge = totalSurchargeToday === '0.00' ? '' : `+ $${totalSurchargeToday}`;
        const showTomorrowSurcharge = totalSurchargeTomorrow === '0.00' ? '' : `+ $${totalSurchargeTomorrow}`;
        const showPickedDateSurcharge = totalSurchargePickedDate === '0.00' || totalSurchargePickedDate === undefined ? '' : `+ $${totalSurchargePickedDate}`;
        const isPLALayout = location.search.includes('adtype=pla');
        const activePLAButton = isPLALayout ? `${classes.deliveryDateOptions} ${classes.deliveryDateOptionsPLA} ${classes.deliveryDateOptionSelected}` : `${classes.deliveryDateOptions} ${classes.deliveryDateOptionSelected}`;
        const notActivePLAButton = isPLALayout ? `${classes.deliveryDateOptions} ${classes.deliveryDateOptionsPLA}` : classes.deliveryDateOptions;
        const isDeliveryDateOptionsSurchargePLA = isPLALayout ? `${classes.deliveryDateOptionsSurchargeMessage} ${classes.deliveryDateOptionsSurchargeMessagePLA}` : classes.deliveryDateOptionsSurchargeMessage;
        const pickADateIconOrSurcharge = dateSelectedFromCalendar && dateSelectedFromCalendar?.data?.deliveryDate ? <p className={isDeliveryDateOptionsSurchargePLA}>Standard charge <br /> {showPickedDateSurcharge}</p> : (
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.3327 1.04169C7.67787 1.04169 7.9577 1.32151 7.9577 1.66669V2.70833H13.3743V1.66669C13.3743 1.32151 13.6542 1.04169 13.9993 1.04169C14.3445 1.04169 14.6243 1.32151 14.6243 1.66669V2.70833H16.4993C17.765 2.70833 18.791 3.73434 18.791 4.99999V16.6667C18.791 17.9323 17.765 18.9583 16.4993 18.9583H4.83268C3.56703 18.9583 2.54102 17.9323 2.54102 16.6667V4.99999C2.54102 3.73434 3.56703 2.70833 4.83268 2.70833H6.7077V1.66669C6.7077 1.32151 6.98752 1.04169 7.3327 1.04169ZM6.7077 3.95833H4.83268C4.25739 3.95833 3.79102 4.4247 3.79102 4.99999V7.70833H17.541V4.99999C17.541 4.4247 17.0746 3.95833 16.4993 3.95833H14.6243V5.00002C14.6243 5.3452 14.3445 5.62502 13.9993 5.62502C13.6542 5.62502 13.3743 5.3452 13.3743 5.00002V3.95833H7.9577V5.00002C7.9577 5.3452 7.67787 5.62502 7.3327 5.62502C6.98752 5.62502 6.7077 5.3452 6.7077 5.00002V3.95833ZM17.541 8.95833H3.79102V16.6667C3.79102 17.242 4.25739 17.7083 4.83268 17.7083H16.4993C17.0746 17.7083 17.541 17.242 17.541 16.6667V8.95833Z" fill="black" />
            </svg>
        );
        if (!dateWithSurchargeAvailable && dateWithoutSurchargeAvailable) {
            return (
                <div className={classes.deliveryDateOptionsContainter}>
                    <div>
                        {this.deliveryDateOptionsCopy()}
                    </div>
                    <div
                        className={classes.deliveryDateButtonsContainer}
                        style={{

                        }}
                    >
                        <button type="button" id="button1" className={activeButton === 'button1' ? activePLAButton : notActivePLAButton} onClick={() => { this.handleDeliveryDateOptionSelected('tomorrow', today, tomorrow, 'button1'); this.handleDeliveryOptionsTracking('Standard Delivery'); }} disabled={(zipValid === false) || (isVaseConfiguratorProduct && !validVaseConfiguratorSku)} data-selected={activeButton === 'button1' && true}>
                            {((zipValid === true && zipField.length >= 5) || (userSubmittedZip !== '' && zipField === userSubmittedZip)) && !productIsNotAvailable ? (
                                <>
                                    <p class="delivery-date">{showDateForFirstButton}</p>
                                    <p className={isDeliveryDateOptionsSurchargePLA}>{showDateForFirstButton ? 'Standard charge' : <GraphqlPortalLoader />}</p>
                                </>
                            ) : (
                                <>
                                    <p className={classes.deliveryDateOptionsNoZip}>Standard</p>
                                    <p className={classes.deliveryDateOptionsNoZip}>delivery</p>
                                </>
                            )}
                        </button>
                        <button type="button" id="button3" className={activeButton === 'button3' ? activePLAButton : notActivePLAButton} onClick={() => { this.handleDeliveryDateOptionSelected('Pick a Date', today, tomorrow, 'button3'); this.handleDeliveryOptionsTracking('Pick a Date'); }} disabled={(zipValid === false) || (isVaseConfiguratorProduct && !validVaseConfiguratorSku)} data-selected={activeButton === 'button3' && true}>
                            {((zipValid === true && zipField.length >= 5) || (userSubmittedZip !== '' && zipField === userSubmittedZip)) && !productIsNotAvailable ? (
                                <>
                                    <p class="delivery-date">{dateSelectedFromCalendar && dateSelectedFromCalendar?.data?.deliveryDate ? formattedPickedDate : 'Pick a Date'}</p>
                                    {pickADateIconOrSurcharge}

                                </>
                            ) : (
                                <>
                                    <p className={classes.deliveryDateOptionsNoZip}>Pick a Date</p>
                                    <p className={classes.zipRequired}>(ZIP required)</p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.3327 1.04169C7.67787 1.04169 7.9577 1.32151 7.9577 1.66669V2.70833H13.3743V1.66669C13.3743 1.32151 13.6542 1.04169 13.9993 1.04169C14.3445 1.04169 14.6243 1.32151 14.6243 1.66669V2.70833H16.4993C17.765 2.70833 18.791 3.73434 18.791 4.99999V16.6667C18.791 17.9323 17.765 18.9583 16.4993 18.9583H4.83268C3.56703 18.9583 2.54102 17.9323 2.54102 16.6667V4.99999C2.54102 3.73434 3.56703 2.70833 4.83268 2.70833H6.7077V1.66669C6.7077 1.32151 6.98752 1.04169 7.3327 1.04169ZM6.7077 3.95833H4.83268C4.25739 3.95833 3.79102 4.4247 3.79102 4.99999V7.70833H17.541V4.99999C17.541 4.4247 17.0746 3.95833 16.4993 3.95833H14.6243V5.00002C14.6243 5.3452 14.3445 5.62502 13.9993 5.62502C13.6542 5.62502 13.3743 5.3452 13.3743 5.00002V3.95833H7.9577V5.00002C7.9577 5.3452 7.67787 5.62502 7.3327 5.62502C6.98752 5.62502 6.7077 5.3452 6.7077 5.00002V3.95833ZM17.541 8.95833H3.79102V16.6667C3.79102 17.242 4.25739 17.7083 4.83268 17.7083H16.4993C17.0746 17.7083 17.541 17.242 17.541 16.6667V8.95833Z" fill="black" />
                                    </svg>
                                </>
                            )}
                        </button>
                    </div>
                </div>
            );
        }

        if (!dateWithoutSurchargeAvailable && dateWithSurchargeAvailable) {
            return (
                <div className={classes.deliveryDateOptionsContainter}>
                    <div>
                        {this.deliveryDateOptionsCopy()}
                    </div>
                    <div
                        className={classes.deliveryDateButtonsContainer}
                        style={{

                        }}
                    >
                        <button type="button" id="button2" className={activeButton === 'button2' ? activePLAButton : notActivePLAButton} onClick={() => { this.handleDeliveryDateOptionSelected('today', today, tomorrow, 'button2'); this.handleDeliveryOptionsTracking('Fastest Delivery'); }} disabled={(zipValid === false) || (isVaseConfiguratorProduct && !validVaseConfiguratorSku)} data-selected={activeButton === 'button2' && true}>
                            {((zipValid === true && zipField.length >= 5) || (userSubmittedZip !== '' && zipField === userSubmittedZip)) && !productIsNotAvailable ? (
                                <>
                                    <p class="delivery-date">{showDateForSecondButton}</p>
                                    <p className={isDeliveryDateOptionsSurchargePLA}>{showDateForSecondButton ? 'Standard charge' : <GraphqlPortalLoader />} <br /> {showTodaySurcharge}</p>
                                </>
                            ) : (
                                <>
                                    <p className={classes.deliveryDateOptionsNoZip}>Fastest</p>
                                    <p className={classes.deliveryDateOptionsNoZip}>delivery</p>
                                </>
                            )}
                        </button>
                        <button type="button" id="button3" className={activeButton === 'button3' ? activePLAButton : notActivePLAButton} onClick={() => { this.handleDeliveryDateOptionSelected('Pick a Date', today, tomorrow, 'button3'); this.handleDeliveryOptionsTracking('Pick a Date'); }} disabled={(zipValid === false) || (isVaseConfiguratorProduct && !validVaseConfiguratorSku)} data-selected={activeButton === 'button3' && true}>
                            {((zipValid === true && zipField.length >= 5) || (userSubmittedZip !== '' && zipField === userSubmittedZip)) && !productIsNotAvailable ? (
                                <>
                                    <p class="delivery-date">{dateSelectedFromCalendar && dateSelectedFromCalendar?.data?.deliveryDate ? formattedPickedDate : 'Pick a Date'}</p>
                                    {pickADateIconOrSurcharge}

                                </>
                            ) : (
                                <>
                                    <p className={classes.deliveryDateOptionsNoZip}>Pick a Date</p>
                                    <p className={classes.zipRequired}>(ZIP required)</p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.3327 1.04169C7.67787 1.04169 7.9577 1.32151 7.9577 1.66669V2.70833H13.3743V1.66669C13.3743 1.32151 13.6542 1.04169 13.9993 1.04169C14.3445 1.04169 14.6243 1.32151 14.6243 1.66669V2.70833H16.4993C17.765 2.70833 18.791 3.73434 18.791 4.99999V16.6667C18.791 17.9323 17.765 18.9583 16.4993 18.9583H4.83268C3.56703 18.9583 2.54102 17.9323 2.54102 16.6667V4.99999C2.54102 3.73434 3.56703 2.70833 4.83268 2.70833H6.7077V1.66669C6.7077 1.32151 6.98752 1.04169 7.3327 1.04169ZM6.7077 3.95833H4.83268C4.25739 3.95833 3.79102 4.4247 3.79102 4.99999V7.70833H17.541V4.99999C17.541 4.4247 17.0746 3.95833 16.4993 3.95833H14.6243V5.00002C14.6243 5.3452 14.3445 5.62502 13.9993 5.62502C13.6542 5.62502 13.3743 5.3452 13.3743 5.00002V3.95833H7.9577V5.00002C7.9577 5.3452 7.67787 5.62502 7.3327 5.62502C6.98752 5.62502 6.7077 5.3452 6.7077 5.00002V3.95833ZM17.541 8.95833H3.79102V16.6667C3.79102 17.242 4.25739 17.7083 4.83268 17.7083H16.4993C17.0746 17.7083 17.541 17.242 17.541 16.6667V8.95833Z" fill="black" />
                                    </svg>
                                </>
                            )}
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div className={classes.deliveryDateOptionsContainter}>
                <div>
                    {this.deliveryDateOptionsCopy()}
                </div>
                <div
                    className={classes.deliveryDateButtonsContainer}
                    style={{

                    }}
                >
                    <button type="button" id="button1" className={activeButton === 'button1' ? activePLAButton : notActivePLAButton} onClick={() => { this.handleDeliveryDateOptionSelected('tomorrow', today, tomorrow, 'button1'); this.handleDeliveryOptionsTracking('Standard Delivery'); }} disabled={(zipValid === false) || (isVaseConfiguratorProduct && !validVaseConfiguratorSku)} data-selected={activeButton === 'button1' && true}>
                        {((zipValid === true && zipField.length >= 5) || (userSubmittedZip !== '' && zipField === userSubmittedZip)) && !productIsNotAvailable ? (
                            <>
                                <p class="delivery-date">{showDateForFirstButton}</p>
                                <p className={isDeliveryDateOptionsSurchargePLA}>{showDateForFirstButton ? 'Standard charge' : <GraphqlPortalLoader />}</p>
                            </>
                        ) : (
                            <>
                                <p className={classes.deliveryDateOptionsNoZip}>Standard</p>
                                <p className={classes.deliveryDateOptionsNoZip}>delivery</p>
                            </>
                        )}
                    </button>
                    <button type="button" id="button2" className={activeButton === 'button2' ? activePLAButton : notActivePLAButton} onClick={() => { this.handleDeliveryDateOptionSelected('today', today, tomorrow, 'button2'); this.handleDeliveryOptionsTracking('Fastest Delivery'); }} disabled={(zipValid === false) || (isVaseConfiguratorProduct && !validVaseConfiguratorSku)} data-selected={activeButton === 'button2' && true}>
                        {((zipValid === true && zipField.length >= 5) || (userSubmittedZip !== '' && zipField === userSubmittedZip)) && !productIsNotAvailable ? (
                            <>
                                <p class="delivery-date">{showDateForSecondButton}</p>
                                <p className={isDeliveryDateOptionsSurchargePLA}>{showDateForSecondButton ? 'Standard charge' : <GraphqlPortalLoader />} <br /> {showTodaySurcharge}</p>
                            </>
                        ) : (
                            <>
                                <p className={classes.deliveryDateOptionsNoZip}>Fastest</p>
                                <p className={classes.deliveryDateOptionsNoZip}>delivery</p>
                            </>
                        )}
                    </button>
                    <button type="button" id="button3" className={activeButton === 'button3' ? activePLAButton : notActivePLAButton} onClick={() => { this.handleDeliveryDateOptionSelected('Pick a Date', today, tomorrow, 'button3'); this.handleDeliveryOptionsTracking('Pick a Date'); }} disabled={(zipValid === false) || (isVaseConfiguratorProduct && !validVaseConfiguratorSku)} data-selected={activeButton === 'button3' && true}>
                        {((zipValid === true && zipField.length >= 5) || (userSubmittedZip !== '' && zipField === userSubmittedZip)) && !productIsNotAvailable ? (
                            <>
                                <p class="delivery-date">{dateSelectedFromCalendar && dateSelectedFromCalendar?.data?.deliveryDate ? formattedPickedDate : 'Pick a Date'}</p>
                                {pickADateIconOrSurcharge}

                            </>
                        ) : (
                            <>
                                <p className={classes.deliveryDateOptionsNoZip}>Pick a Date</p>
                                <p className={classes.zipRequired}>(ZIP required)</p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.3327 1.04169C7.67787 1.04169 7.9577 1.32151 7.9577 1.66669V2.70833H13.3743V1.66669C13.3743 1.32151 13.6542 1.04169 13.9993 1.04169C14.3445 1.04169 14.6243 1.32151 14.6243 1.66669V2.70833H16.4993C17.765 2.70833 18.791 3.73434 18.791 4.99999V16.6667C18.791 17.9323 17.765 18.9583 16.4993 18.9583H4.83268C3.56703 18.9583 2.54102 17.9323 2.54102 16.6667V4.99999C2.54102 3.73434 3.56703 2.70833 4.83268 2.70833H6.7077V1.66669C6.7077 1.32151 6.98752 1.04169 7.3327 1.04169ZM6.7077 3.95833H4.83268C4.25739 3.95833 3.79102 4.4247 3.79102 4.99999V7.70833H17.541V4.99999C17.541 4.4247 17.0746 3.95833 16.4993 3.95833H14.6243V5.00002C14.6243 5.3452 14.3445 5.62502 13.9993 5.62502C13.6542 5.62502 13.3743 5.3452 13.3743 5.00002V3.95833H7.9577V5.00002C7.9577 5.3452 7.67787 5.62502 7.3327 5.62502C6.98752 5.62502 6.7077 5.3452 6.7077 5.00002V3.95833ZM17.541 8.95833H3.79102V16.6667C3.79102 17.242 4.25739 17.7083 4.83268 17.7083H16.4993C17.0746 17.7083 17.541 17.242 17.541 16.6667V8.95833Z" fill="black" />
                                </svg>
                            </>
                        )}
                    </button>
                </div>
            </div>
        );
    }

    render() {
        const {
            showCalendar,
            showAgeVerification,
            calendarIsLoading,
            deliveryAvailable,
            ageDetails,
            todayTomDateNotAvailText,
            zipField,
            signinIsLoading,
            personalization,
            fireCalendarQuery,
            gptSkipCalendarVariantFlowEnabled,
            flexModalOpen,
            flexData,
            flexTaggingData,
            todayTomArray,
            deliveryDateOption,
            dateSelectedFromCalendar,
            activeButton,
            optionOneDate,
            optionTwoDate,
            deliveryDateOptionsFlexDetails,
            personalizationAdded,
            flexDetailsAvailable,
        } = this.state;
        const {
            auth,
            classes,
            locationType,
            userSubmittedZip,
            selectedSku,
            zipValid,
            productDeliveryType,
            brandId,
            brand,
            deliveryData,
            isAuthenticated,
            partNumber,
            addressBookEntries,
            addressBookPageOn,
            addressBookTotalPages,
            totalAddresses,
            callLoadAddressBook,
            productName,
            trackEvent,
            featureFlags,
            isPassportBundleItem,
            validatedZip,
            displayDeliveryCalendar,
            movieSelected,
            handleMobileAgeVerification,
            hasWine,
            location: { state, search },
            isPassportBundleProduct,
            isFlowersSubscriptionFeatureEnabled,
            isFlowersTempV1SubscriptionFeatureEnabled,
            subscription,
            subscriptionDetails,
            handleMiniCartModalClick,
            enableMinicart,
            productNotAvailable,
            isStandAloneMovieSku,
            pmallSummaryInfo,
            activeABTests,
            validVaseConfiguratorSku,
            presentationFamily,
            showWrapup,
            isWriteScopeCheckout,
            isAccessBasedOnScopeEnabled,
            isPlaPage,
            productSkus,
            productCategories,
            device,
            content,
            isPdpRedesignEnabled,
            showAddToCart,
            showDeliveryField,
            showProductTitleTop,
            isPdpRedesignShortEnabled,
            addToCartButtonRedesign,
            isPlaRedesignEnabled,
            isPersistAddressEnabled,
            isWrapUpEnabled,
            salesforceResponseWrapUpShowHide,
            variantDeliveryOptions,
            categoryId,
            variantAddon,
        } = this.props;

        const isDeliveryDateOptionsEnabled = featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled'] && variantDeliveryOptions;
        if (isDeliveryDateOptionsEnabled && window && typeof window !== 'undefined') {
            if (deliveryDateOptionsFlexDetails) {
                window.dispatchEvent(new CustomEvent('flexdetails', { detail: deliveryDateOptionsFlexDetails }));
            }
        }
        const isInternationalProduct = this.isInternationalProduct();
        const internationalCountry = this.getInternationalCountry();
        const locationTypeOptions = deliveryData.location_type_options || [];
        const isAddressBookEnabled = featureFlags['is-address-book-service-enabled'];
        const categoryPath = state?.categoryPath || '';
        const isCanadian = getCountryCodeByCategoryPath(categoryPath).countryName === 'Canada';
        const isGPTCalendarButtonTextTestActive = activeABTests.gpt_calendar_button_text === 'VARIANT A';
        const isPdpDeliveryTopEnabled = isPdpRedesignEnabled && featureFlags['is-pdp-delivery-top-enabled'] && device === 'mobile' && showProductTitleTop;

        let pdpReskinStyle = '';
        if (isPlaRedesignEnabled) {
            pdpReskinStyle = `${classes.newProductUI} ${classes.pdpPlaStyle}`;
        } else if (isPdpRedesignShortEnabled) {
            pdpReskinStyle = `${classes.newProductUI} ${classes.pdpShortStyle}`;
        } else if (isPdpRedesignEnabled) {
            pdpReskinStyle = classes.newProductUI;
        }
        const isPmallProduct = featureFlags['is-pmall-enabled'] && (brandId === '1030' || brandId === '1033');
        // TODO bladerunner: temp solution until i can confirm product data is sound
        const isVaseConfiguratorProduct = featureFlags['is-vase-configurator-enabled'] && isVaseConfigProduct(partNumber);

        const floralPLARedesign = activeABTests.is_floral_pla_redesign === 'VARIANT';
        let PLAContainerDesign = false;
        if (isPlaPage && device === 'mobile' && !isPlaRedesignEnabled) {
            PLAContainerDesign = true;
        } else if (isPlaPage && device !== 'mobile' && floralPLARedesign) {
            PLAContainerDesign = true;
        }
        let addToCartDisplatStep = 2;
        if (isPmallProduct) addToCartDisplatStep = 3;

        const handleDeliveryTitle = () => {
            if ((featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar) || isPdpRedesignEnabled) {
                return isPdpDeliveryTopEnabled ? 'Delivery Address' : `${isDeliveryDateOptionsEnabled ? 'Delivery Details' : 'Enter Delivery Destination'}`;
            }
            return `${addToCartDisplatStep}. Enter Delivery Destination`;
        };

        const displayFlowersLocationTypes = () => {
            if (locationTypeOptions.length > 0) {
                return (
                    locationTypeOptions.map((location) => (
                        <MenuItem
                            value={location.name}
                            key={location.name}
                        >
                            {location.name}
                        </MenuItem>
                    ))
                );
            }
            return (
                backupLocationTypeOptions.map((location) => (
                    <MenuItem
                        value={location}
                        key={location}
                    >
                        {location}
                    </MenuItem>
                ))
            );
        };
        const displayFlowersLocationNewTypes = () => {
            if (locationTypeOptions.length > 0) {
                return (
                    locationTypeOptions.map((location) => (
                        <option aria-hidden="true" value={location.name}>{location.name}</option>
                    ))
                );
            }
            return (
                backupLocationTypeOptions.map((location) => (
                    <option aria-hidden="true" value={location}>{location}</option>
                ))
            );
        };

        const selectInput = () => (
            <div className={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.locationWrapperV2 : classes.locationWrapper}>
                <InputLabel
                    className={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.locationTypeLabelV2 : classes.locationTypeLabel}
                    shrink
                    htmlFor="location-type"
                >
                    {deliveryData.location_type_title || 'Location Type'}
                </InputLabel>
                <Select
                    className={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.locationTypeSelectorV2 : classes.locationTypeSelector}
                    inputProps={{
                        name: 'location-type',
                        id: 'location-type',
                        label: 'location-type',
                    }}
                    name="Location Type"
                    data-test="pdp-select-location"
                    id="select-location-type"
                    value={locationType}
                    onChange={this.handleLocationTypeChange}
                    disableUnderline={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar && 'true'}
                >
                    {featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar && foodBrandLocationTypeOptions.map((location) => (
                        <MenuItem
                            value={location}
                            key={location}
                        >
                            {location}
                        </MenuItem>
                    ))}
                    {!featureFlags['is-new-delivery-calendar-enabled'] && displayFlowersLocationTypes()}
                </Select>
            </div>
        );
        const showFlexModal = () => {
            if (isDeliveryDateOptionsEnabled) {
                return <FlexibleShippingOptions flexAddToCartDeliveryOptions={this.flexTodayTomorrowAddToCart} handleFlexDetails={this.handleFlexDetails} flexData={flexData} isOpen handleFlexClose={this.handleFlexClose} flexTaggingData={flexTaggingData} isDeliveryDateOptionsEnabled={isDeliveryDateOptionsEnabled} activeButton={activeButton} deviceType={device} />;
            }
            return <FlexModal flexAddToCart={this.flexTodayTomorrowAddToCart} flexData={flexData} isOpen handleFlexClose={this.handleFlexClose} flexTaggingData={flexTaggingData} />;
        };
        return (
            <div className={pdpReskinStyle}>
                {flexModalOpen && flexData && showFlexModal()}
                {!deliveryAvailable && userSubmittedZip && <GraphqlProductNotAvailableModal selectedSku={selectedSku} isOpen={!deliveryAvailable && userSubmittedZip} onClose={this.handleProductNotAvailableClose} productName={productName} brand={brand['domain-name']} trackEvent={trackEvent} productNotAvailable={productNotAvailable} />}
                {calendarIsLoading && !(!deliveryAvailable && userSubmittedZip !== '') ? <GraphqlPortalLoader /> : null}
                {signinIsLoading ? <GraphqlPortalLoader /> : null}
                {selectedSku.personalization?.lines && <PersonalizationModal isOpen={personalization.modalOpen} personalization={selectedSku.personalization} setPersonalizationState={this.setPersonalizationState} personalizationState={personalization} handlePersonalizationTextFieldChange={this.handlePersonalizationTextFieldChange} handlePersonalizationModalSubmit={this.handlePersonalizationModalSubmit} closePersonalizationModal={this.closePersonalizationModal} content={content} />}
                <Paper elevation={PLAContainerDesign ? 0 : 1} className={`${classes.root} ${PLAContainerDesign ? classes.containerPosition : ''} ${isPdpDeliveryTopEnabled  ? classes.deliveryWrapper : ''}`}>
                    {!PLAContainerDesign && showDeliveryField && (
                        <div className={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.paperHeaderV2 : `${(displayDeliveryCalendar && !featureFlags['is-zip-override-fallback-enabled'] && !gptSkipCalendarVariantFlowEnabled) ? classes.paperHeader : null} ${isProductListingAd(search) ? classes.paperHeaderPla : ''}`}>
                            {(displayDeliveryCalendar && !featureFlags['is-zip-override-fallback-enabled'] && !gptSkipCalendarVariantFlowEnabled && !isPdpRedesignShortEnabled && !isPlaRedesignEnabled) && <div className={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.pdpDeliveryV2 : classes.pdpDelivery} role="heading" aria-level="5">{handleDeliveryTitle()}</div>}
                            {
                                isAddressBookEnabled && !isInternationalProduct && (displayDeliveryCalendar
                                    && !featureFlags['is-zip-override-fallback-enabled']) && !gptSkipCalendarVariantFlowEnabled
                                && !isStandAloneMovieSku
                                && (
                                    <div>
                                        {!isAuthenticated && (
                                            <div
                                                className={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.paperHeaderLinkV2 : classes.paperHeaderLink}
                                                role="button"
                                                tabIndex={-1}
                                                onKeyDown={() => { }}
                                                onClick={async () => {
                                                    trackEvent({
                                                        eventCategory: 'Sign In', eventAction: 'Login', eventLabel: 'Logon_From_Normal|<<pageType>>',
                                                    });

                                                    await auth.loginByRedirect();
                                                }}
                                                data-test="pdp-address-book"
                                                id="address-book-signin"
                                                name="pdpSignin"
                                            >
                                                {isPdpDeliveryTopEnabled  || isPlaRedesignEnabled ? 'Sign In For Contacts' :  'Sign in to access your contacts'}
                                            </div>
                                        )}
                                        {isAuthenticated && isWriteScopeCheckout && (
                                            <AddressBookWithPagination
                                                name="pdpAddressBook"
                                                entries={addressBookEntries}
                                                onSelectedAddress={this.handleSelectedAddressBook}
                                                loadAddressBook={callLoadAddressBook}
                                                handleRemoveAddressBook={this.handleRemoveAddressBook}
                                                handleChangeAddressBook={() => { }}
                                                pageOn={addressBookPageOn}
                                                noOfPages={addressBookTotalPages}
                                                totalAddresses={totalAddresses}
                                                isAccessBasedOnScopeEnabled={isAccessBasedOnScopeEnabled}
                                                pageType="pdp"
                                                isPdpRedesignEnabled={isPdpRedesignEnabled}
                                                isCCONewCalenadarEnabled={featureFlags['is-new-delivery-calendar-enabled']}
                                                displayDeliveryCalendar={displayDeliveryCalendar}
                                                isPdpDeliveryTopEnabled={isPdpDeliveryTopEnabled}
                                                isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
                                                isPlaRedesignEnabled={isPlaRedesignEnabled}
                                            />
                                        )}
                                        {isAuthenticated && !isWriteScopeCheckout && <LimitedAccessReSignInLink />}
                                    </div>
                                )
                            }
                        </div>
                    )}
                    <div className={classes.paperBody}>
                        <form noValidate autoComplete="off">
                            { /* avoid displaying zipcode and location type fields for international products */}
                            {!isInternationalProduct && showDeliveryField && (displayDeliveryCalendar && !featureFlags['is-zip-override-fallback-enabled']) && !gptSkipCalendarVariantFlowEnabled && (
                                <>
                                    <div className={classes.formContainer}>
                                        <div className={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? classes.formWrapperV2 : classes.formWrapper}>
                                            <DesktopMobile
                                                desktop={() => (
                                                    <>
                                                        <TextField
                                                            className={this.displayZipValidCSSCheck()}
                                                            style={{ border: featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? '1px solid #C4C4C4' : '', borderRadius: featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? '3px' : '' }}
                                                            margin="normal"
                                                            id="add-zipcode-text-field"
                                                            data-test="pdp-zipcode-text-field"
                                                            data-testid="pdp-zipcode-text-field"
                                                            name="zipcodeTextField"
                                                            label={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? 'Zip Code*' : (deliveryData.zip_code_title || 'Delivery Zip Code*')}
                                                            onKeyPress={this.handleZipFieldKeyPress}
                                                            onChange={this.handleZipChange}
                                                            // defaultValue={userSubmittedZip}
                                                            value={zipField || validatedZip}
                                                            inputRef={this.zipFieldRef}
                                                            InputProps={(featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar) || isPdpRedesignEnabled ? { disableUnderline: true } : { disableUnderline: false }}
                                                        />
                                                        {featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar && this.renderZipVerificationSvg()}
                                                    </>
                                                )}
                                                mobile={() => (
                                                    <>
                                                        <TextField
                                                            variant={isPdpRedesignEnabled ? 'outlined' : 'standard'}
                                                            error={!!(!zipField && fireCalendarQuery)}
                                                            className={this.displayZipValidCSSCheck()}
                                                            margin="normal"
                                                            id="add-zipcode-text-field"
                                                            data-test="pdp-zipcode-text-field"
                                                            data-testid="pdp-zipcode-text-field"
                                                            name="zipcodeTextField"
                                                            label={((featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar) || isPdpDeliveryTopEnabled) ? (`${isPdpDeliveryTopEnabled ? 'ZIP Code*' : 'Zip Code*'}`) : deliveryData.zip_code_title || 'Delivery Zip Code*'}
                                                            onKeyPress={this.handleZipFieldKeyPress}
                                                            onChange={this.handleZipChange}
                                                            type={isCanadian ? 'text' : 'tel'}
                                                            value={zipField || validatedZip}
                                                            inputRef={this.zipFieldRef}
                                                            InputProps={featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar ? { disableUnderline: true } : { disableUnderline: false }}
                                                        />
                                                        {featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar && this.renderZipVerificationSvg()}
                                                    </>
                                                )}
                                            />
                                        </div>
                                        {
                                            isPdpRedesignEnabled
                                                ? (
                                                    <FormControl className={classes.locationForm} role="region" aria-label="SelectLocation" variant="outlined">
                                                        <InputLabel
                                                            className={`${classes.locationTypeLabel} ${classes.selectLabel}`}
                                                            htmlFor="location-type"
                                                        >
                                                            {isPdpDeliveryTopEnabled ? 'Location*' : ' Location Type*'}
                                                        </InputLabel>
                                                        <NativeSelect
                                                            defaultValue=""
                                                            className={`${classes.locationSelect}`}
                                                            value={locationType}
                                                            data-testid="pdp-frequency-type"
                                                            disableUnderline
                                                            onChange={this.handleLocationTypeChange}
                                                            inputProps={{
                                                                name: 'location-type',
                                                                id: 'location-type',
                                                                'aria-hidden': 'true',
                                                                tabIndex: '-1',
                                                            }}
                                                        >
                                                            {featureFlags['is-new-delivery-calendar-enabled'] && displayDeliveryCalendar && foodBrandLocationTypeOptions.map((location) => (
                                                                <option aria-hidden="true" value={location}>{location}</option>

                                                            ))}
                                                            {!featureFlags['is-new-delivery-calendar-enabled'] && displayFlowersLocationNewTypes()}
                                                        </NativeSelect>
                                                    </FormControl>
                                                )
                                                : (
                                                    selectInput()
                                                )
                                        }
                                    </div>
                                    {isDeliveryDateOptionsEnabled && this.deliveryDateOptionButtons()}

                                </>
                            )}
                            {variantAddon && isDeliveryDateOptionsEnabled && (
                                <div className={classes.addonWrapper}>
                                    {((zipValid === true && zipField.length >= 5 && deliveryDateOption?.trim() && deliveryDateOption !== 'Pick a Date') || (userSubmittedZip !== '' && zipField === userSubmittedZip && deliveryDateOption?.trim() && deliveryDateOption !== 'Pick a Date')) ? (
                                        <PDPAddonContainer productCode={selectedSku?.id} productBaseCode={partNumber} zipCode={zipField || validatedZip} selectedDate={deliveryDateOption} categoryId={categoryId} pdpContent={content} />
                                    ) : (
                                        <PDPAddonMessage
                                            pdpContent={content}
                                            isZipVaild={zipValid === false || zipField.length < 5}
                                        />
                                    )}
                                </div>
                            )}
                            {isVaseConfiguratorProduct && !validVaseConfiguratorSku
                                && <VaseConfigATCError />}
                            {showAddToCart && <AddToCarErrorInline />}
                            {showAddToCart && (
                                <DeliveryCalendarButtonContainer
                                    addTodayOrTomToCart={this.addTodayOrTomToCart}
                                    fullCalendarCall={() => {
                                        this.handleAgeVerify(handleMobileAgeVerification, hasWine);
                                    }}
                                    zipValid={zipValid}
                                    productDeliveryType={productDeliveryType}
                                    isInternationalProduct={isInternationalProduct}
                                    todayTomorrowFlagEnabled={featureFlags['is-today-tomorrow-enabled']}
                                    displayDeliveryCalendar={(displayDeliveryCalendar && !featureFlags['is-zip-override-fallback-enabled'] && !gptSkipCalendarVariantFlowEnabled)}
                                    pmallAddToCartDisabled={isPmallProduct && !pmallSummaryInfo?.customizations?.refnum}
                                    vaseConfiguratorDisabled={isVaseConfiguratorProduct && !validVaseConfiguratorSku}
                                    trackEvent={trackEvent}
                                    isGPTCalendarButtonTextTestActive={isGPTCalendarButtonTextTestActive}
                                    presentationFamily={presentationFamily}
                                    deliveryCalendarEnable={featureFlags['is-new-delivery-calendar-enabled']}
                                    brandId={brandId}
                                    isPdpRedesignEnabled={isPdpRedesignEnabled}
                                    addToCartButtonRedesign={addToCartButtonRedesign}
                                    selectedSku={selectedSku}
                                    deliveryDateOptionsFlagEnabled={featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled']}
                                    deliveryDateOption={deliveryDateOption}
                                    variantDeliveryOptions={variantDeliveryOptions}
                                    dateSelectedFromCalendar={dateSelectedFromCalendar}
                                    deliveryDateOptionsFlexDetails={deliveryDateOptionsFlexDetails}
                                    flexTodayTomorrowAddToCart={this.flexTodayTomorrowAddToCart}
                                    updatePersonalizationState={this.updatePersonalizationState}
                                    personalizationAdded={personalizationAdded}
                                    flexDetailsAvailable={flexDetailsAvailable}
                                    locationType={locationType}
                                />
                            )}
                            {isPdpRedesignEnabled && showAddToCart && <div><KlarnaCreditPromotionBadge selectedSku={selectedSku} /></div>}
                            {!isVaseConfiguratorProduct && (
                                <OneClickPaymentBuilder
                                    selectedSku={selectedSku}
                                    movieSelected={movieSelected}
                                    isStandAloneMovieSku={isStandAloneMovieSku}
                                    productCategories={productCategories}
                                />
                            )}
                            {fireCalendarQuery && (
                                <GraphqlCalendarContainer
                                    close={this.closeCalendar}
                                    isOpen={showCalendar}
                                    selectedItemId={selectedSku?.id}
                                    selectedSku={selectedSku}
                                    productDeliveryType={productDeliveryType}
                                    productName={productName}
                                    brandId={brandId}
                                    ageDetails={ageDetails}
                                    setCalendarDataLoadingFlag={
                                        this.setCalendarDataLoadingFlag
                                    }
                                    handleDeliveryAvailability={
                                        this.handleDeliveryAvailability
                                    }
                                    partNumber={partNumber}
                                    todayTomDateNotAvailText={todayTomDateNotAvailText}
                                    isInternationalProduct={isInternationalProduct}
                                    internationalCountry={internationalCountry}
                                    isPassportBundleItem={isPassportBundleItem}
                                    validatedZip={validatedZip}
                                    personalization={personalization}
                                    movieSelected={movieSelected}
                                    isPassportBundleProduct={isPassportBundleProduct || {}}
                                    hasWine={selectedSku?.ageVerifyFlag}
                                    isFlowersSubscriptionFeatureEnabled={isFlowersSubscriptionFeatureEnabled}
                                    isFlowersTempV1SubscriptionFeatureEnabled={isFlowersTempV1SubscriptionFeatureEnabled}
                                    subscription={subscription}
                                    subscriptionDetails={subscriptionDetails}
                                    handleMiniCartModalClick={handleMiniCartModalClick}
                                    enableMinicart={enableMinicart}
                                    showWrapup={showWrapup}
                                    productSkus={productSkus}
                                    displayDeliveryCalendar={displayDeliveryCalendar}
                                    isPersistAddressEnabled={isPersistAddressEnabled}
                                    isWrapUpEnabled={isWrapUpEnabled}
                                    salesforceResponseWrapUpShowHide={salesforceResponseWrapUpShowHide}
                                    handlePickADate={this.handlePickADate}
                                    isDeliveryDateOptionsEnabled={isDeliveryDateOptionsEnabled}
                                    deliveryDateOption={deliveryDateOption}
                                />
                            )}
                            {showAgeVerification
                                && (
                                    <ConnectedProductAgeVerificationModal
                                        isOpen={showAgeVerification}
                                        setCalendarDataLoadingFlag={
                                            this.setCalendarDataLoadingFlag
                                        }
                                        handleAgeVerificationClose={
                                            this.handleAgeVerificationClose
                                        }
                                        getAgeVerificationDetails={
                                            this.getAgeVerificationDetails
                                        }
                                    />
                                )}
                        </form>
                    </div>
                </Paper>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locationType: getLocationType(state),
    brand: getBrand(state),
    validatedZip: getValidatedZipcode(state),
    zipValid: getIsProductFilterZipcodeValid(state),
    userSubmittedZip: getUserSubmittedProductFilterZipcode(state),
    isAuthenticated: getIsAuthenticatedStatus(state),
    savedAddress: getSavedAddress(state),
    addressBookEntries: getAddressBookEntries(state),
    addressBookPageOn: getAddressBookPageNumber(state),
    addressBookTotalPages: getTotalNoOfPages(state),
    totalAddresses: getTotalEntriesAddressBook(state),
    userType: getUserType(state),
    // featureFlags: getFeatureFlags(state), will get from prop from parent comp
    wineValidation: getWineData(state),
    passportInCart: getPassportSubscriptionStatus(state),
    isPassportUser: getIsPassportUserLoggedIn(state),
    activeABTests: getActiveABTests(state),
    // presentationFamily: getPresentationFamily(state), will get from prop from parent comp
    isWriteScopeCheckout: getIsWriteScopeCheckout(state),
    isAccessBasedOnScopeEnabled: getFeatureFlag('is-access-based-on-scope-enabled')(state),
    subscriptionValues: getSubscriptionFrequencyData(state),
    deviceType: getSSRDeviceType(state),
});

const mapDispatchToProps = (dispatch) => ({
    setLocation: bindActionCreators(setLocationType, dispatch),
    // this is the same as: resetFilterZipcodeValidity
    resetZipValidity: bindActionCreators(
        resetProductFilterZipcodeValidity,
        dispatch,
    ),
    setZipcodeValidity: bindActionCreators(setProductFilterZipcodeValidity, dispatch),
    valZip: bindActionCreators(validateProductFilterZipcode, dispatch),
    clearValidatedZip: bindActionCreators(clearValidatedZipcode, dispatch),
    setFilterZip: bindActionCreators(
        setUserSubmittedProductFilterZipcode,
        dispatch,
    ),
    setValZip: bindActionCreators(setValidatedZipcode, dispatch),
    clearFilterZip: bindActionCreators(clearUserSubmittedProductFilterZipcode, dispatch),
    // this is the same as resetFilterZipcodeValidity
    resetFilterZipcodeValidity: bindActionCreators(resetProductFilterZipcodeValidity, dispatch),
    clearSavedAddress: bindActionCreators(clearUserSelectedAddress, dispatch),
    actionAddToCart: bindActionCreators(addToCartNewCartServices, dispatch),
    callLoadAddressBook: bindActionCreators(loadAddressBook, dispatch),
    callRemoveAddressBook: bindActionCreators(removeAddressBook, dispatch),
    setSelectedAddress: bindActionCreators(setUserSelectedAddress, dispatch),
    trackEvent: bindActionCreators(tagManagerActions.trackEvent, dispatch),
    queueEvent: bindActionCreators(tagManagerActions.queueEvent, dispatch),
    callVerifyWine: bindActionCreators(verifyWine, dispatch),
});

GraphqlAddToCartContainerUI.propTypes = {
    auth: shape({
        loginByRedirect: func.isRequired,
        getAccessTokenSafely: func.isRequired,
    }).isRequired,
    classes: object.isRequired,
    locationType: string.isRequired,
    validatedZip: string.isRequired,
    zipValid: bool,
    setLocation: func.isRequired,
    resetZipValidity: func.isRequired,
    brand: object.isRequired,
    valZip: func.isRequired,
    clearValidatedZip: func.isRequired,
    userSubmittedZip: string.isRequired,
    setValZip: func.isRequired,
    selectedSku: shape({
        __typename: string.isRequired,
        id: string.isRequired,
        name: string.isRequired,
    }),
    setFilterZip: func.isRequired,
    productDeliveryType: string.isRequired,
    passportInCart: bool,
    productCategories: array.isRequired,
    productSkus: arrayOf(
        shape({
            id: string.isRequired,
            name: string.isRequired,
            ageVerifyFlag: string.isRequired,
            minAge: string.isRequired,
            prices: arrayOf(
                shape({
                    type: string.isRequired,
                    value: number.isRequired,
                }),
            ),
            isInternational: bool.isRequired,
        }),
    ).isRequired,
    brandId: string.isRequired,
    deliveryData: shape({
        location_type_options: arrayOf(
            shape({
                name: string.isRequired,
                value: string,
            }),
        ),
        show: bool.isRequired,
        title: string.isRequired,
        zip_code_title: string.isRequired,
        location_type_title: string.isRequired,
    }).isRequired,
    isAuthenticated: bool.isRequired,
    clearFilterZip: func.isRequired,
    clearSavedAddress: func.isRequired,
    setZipcodeValidity: func.isRequired,
    savedAddress: shape({
        addressSource: string,
        addressComponents: arrayOf(
            shape({ // This shape is for addresses saved from google places. More will be added when aditional address sources are added
                long_name: string.isRequired,
                short_name: string.isRequired,
                types: arrayOf(
                    string,
                ).isRequired,
            }),
        ),
    }).isRequired,
    isPassportUser: bool,
    partNumber: string.isRequired,
    actionAddToCart: func.isRequired,
    history: object.isRequired,
    location: object.isRequired,
    resetFilterZipcodeValidity: func.isRequired,
    callLoadAddressBook: func.isRequired,
    userType: string.isRequired,
    callRemoveAddressBook: func.isRequired,
    setSelectedAddress: func.isRequired,
    addressBookEntries: array.isRequired,
    addressBookPageOn: number.isRequired,
    addressBookTotalPages: number.isRequired,
    totalAddresses: number.isRequired,
    trackEvent: func.isRequired,
    productName: string.isRequired,
    featureFlags: object.isRequired,
    isPassportBundleItem: bool.isRequired,
    displayDeliveryCalendar: bool.isRequired,
    movieSelected: shape({
        error: bool,
        skuSelected: shape({
            sku: string.isRequired,
            sku_description: string.isRequired,
            sku_price: number.isRequired,
        }),
    }),
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        enable: bool,
    }),
    categoryId: string,
    categoryPath: string,
    categoryName: string,
    handleMobileAgeVerification: func,
    hasWine: bool,
    callVerifyWine: func.isRequired,
    wineValidation: shape({
        wineAvailability: object, // object type array
        wineVerify: shape({
            birthDay: 'string',
            birthMonth: 'string',
            birthYear: 'string',
            minAge: 'string',
        }),
    }),
    isFlowersSubscriptionFeatureEnabled: bool.isRequired,
    isFlowersTempV1SubscriptionFeatureEnabled: bool.isRequired,
    subscriptionDetails: shape({
        subscriptionType: string,
        subscriptionDuration: string,
        subscriptionFrequency: string,
    }),
    subscriptionValues: shape({
        duration: string,
        subscriptionType: string,
    }),
    subscription: shape({
        subscriptionKey: array,
        subscriptionIndefinite: string,
        subscriptionType: array,
        implementProductSubscription: bool,
        viewSubscription: bool,
        isTypeDiscovery: bool,
    }),
    handleMiniCartModalClick: func.isRequired,
    enableMinicart: bool.isRequired,
    productNotAvailable: shape({
        product_not_available_text: string.isRequired,
        cta_text: string.isRequired,
    }),
    isStandAloneMovieSku: bool,
    pmallSummaryInfo: shape({
        customizations: arrayOf(
            shape({
                refnum: string,
                description: string,
                'preview-url': string,
            }),
        ),
    }).isRequired,
    activeABTests: object,
    validVaseConfiguratorSku: bool.isRequired,
    presentationFamily: string,
    showWrapup: string,
    isWriteScopeCheckout: bool.isRequired,
    isAccessBasedOnScopeEnabled: bool.isRequired,
    device: string.isRequired,
    isPlaPage: bool,
    content: object,
    isPdpRedesignEnabled: bool,
    showAddToCart: bool,
    showDeliveryField: bool,
    showProductTitleTop: bool,
    isPdpRedesignShortEnabled: bool,
    addToCartButtonRedesign: bool,
    isPlaRedesignEnabled: bool,
    isPersistAddressEnabled: bool,
    isWrapUpEnabled: bool,
    salesforceResponseWrapUpShowHide: object,
    variantDeliveryOptions: bool.isRequired,
    variantAddon: bool,
    selectAddons: array,
};

GraphqlAddToCartContainerUI.defaultProps = {
    zipValid: null,
    selectedSku: null,
    movieSelected: null,
    isPassportBundleProduct: {},
    categoryId: '',
    categoryPath: '',
    categoryName: '',
    handleMobileAgeVerification: () => { },
    hasWine: false,
    wineValidation: null,
    subscriptionDetails: {},
    subscriptionValues: {},
    subscription: {},
    productNotAvailable: {},
    isStandAloneMovieSku: false,
    passportInCart: false,
    isPassportUser: false,
    activeABTests: {},
    presentationFamily: '',
    showWrapup: 'true',
    isPlaPage: false,
    content: {},
    isPdpRedesignEnabled: false,
    showAddToCart: true,
    showDeliveryField: true,
    showProductTitleTop: false,
    isPdpRedesignShortEnabled: false,
    addToCartButtonRedesign: false,
    isPlaRedesignEnabled: false,
    isPersistAddressEnabled: false,
    isWrapUpEnabled: false,
    salesforceResponseWrapUpShowHide: {},
    variantAddon: false,
    selectAddons: [],
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    withAuth,
    withStyles(styles),
)(GraphqlAddToCartContainerUI);
